var _defs, _rect, _image, _path, _path2, _path3, _image2, _path4, _image3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon, _path13, _polygon2, _path14, _polygon3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _polyline, _g, _polygon4, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _image4, _image5, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _polygon5, _path98, _polygon6, _path99, _polygon7, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _polyline2, _g2, _polygon8, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _image6, _image7, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg11S(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 168.55 230.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-3{fill:#231f20;}.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-11,.cls-110,.cls-111,.cls-112,.cls-113,.cls-115,.cls-116,.cls-12,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-13,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-14,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-15,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-158,.cls-159,.cls-16,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-17,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-18,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-19,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-195,.cls-196,.cls-197,.cls-198,.cls-199,.cls-20,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-21,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-219,.cls-22,.cls-220,.cls-221,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{fill-rule:evenodd;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:#fde4e0;}.cls-6{fill:#bc9133;}.cls-7{fill:#eec265;}.cls-8{fill:url(#linear-gradient-2);}.cls-115,.cls-9{fill:#fff;}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:url(#linear-gradient-10);}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{fill:url(#linear-gradient-14);}.cls-22{fill:url(#linear-gradient-15);}.cls-23{fill:url(#linear-gradient-16);}.cls-24{fill:url(#linear-gradient-17);}.cls-25{fill:url(#linear-gradient-18);}.cls-26{fill:url(#linear-gradient-19);}.cls-27{fill:url(#linear-gradient-20);}.cls-28{fill:url(#linear-gradient-21);}.cls-29{fill:url(#linear-gradient-22);}.cls-30{fill:url(#linear-gradient-23);}.cls-31{fill:url(#linear-gradient-24);}.cls-32{fill:url(#linear-gradient-25);}.cls-33{fill:url(#linear-gradient-26);}.cls-34{fill:url(#linear-gradient-27);}.cls-35{fill:url(#linear-gradient-28);}.cls-36{fill:url(#linear-gradient-29);}.cls-37{fill:url(#linear-gradient-30);}.cls-38{fill:url(#linear-gradient-31);}.cls-39{fill:url(#linear-gradient-32);}.cls-40{fill:url(#linear-gradient-33);}.cls-41{fill:url(#linear-gradient-34);}.cls-42{fill:url(#linear-gradient-35);}.cls-43{fill:url(#linear-gradient-36);}.cls-44{fill:url(#linear-gradient-37);}.cls-45{fill:url(#linear-gradient-38);}.cls-46{fill:url(#linear-gradient-39);}.cls-47{fill:#5c5d60;}.cls-48{fill:url(#linear-gradient-40);}.cls-49{clip-path:url(#clip-path);}.cls-50{fill:url(#linear-gradient-41);}.cls-51{fill:url(#linear-gradient-42);}.cls-52{fill:url(#linear-gradient-43);}.cls-53{fill:url(#linear-gradient-44);}.cls-54{fill:url(#linear-gradient-45);}.cls-55{fill:url(#linear-gradient-46);}.cls-56{fill:url(#linear-gradient-47);}.cls-57{fill:url(#linear-gradient-48);}.cls-58{fill:url(#linear-gradient-49);}.cls-59{fill:url(#linear-gradient-50);}.cls-60{fill:url(#linear-gradient-51);}.cls-61{fill:url(#linear-gradient-52);}.cls-62{fill:url(#linear-gradient-53);}.cls-63{fill:url(#linear-gradient-54);}.cls-64{fill:url(#linear-gradient-55);}.cls-65{fill:url(#linear-gradient-56);}.cls-66{fill:url(#linear-gradient-57);}.cls-67{fill:url(#linear-gradient-58);}.cls-68{fill:url(#linear-gradient-59);}.cls-69{fill:url(#linear-gradient-60);}.cls-70{fill:url(#linear-gradient-61);}.cls-71{fill:url(#linear-gradient-62);}.cls-72{fill:url(#linear-gradient-63);}.cls-73{fill:url(#linear-gradient-64);}.cls-74{fill:url(#linear-gradient-65);}.cls-75{fill:url(#linear-gradient-66);}.cls-76{fill:url(#linear-gradient-67);}.cls-77{fill:url(#linear-gradient-68);}.cls-78{fill:url(#linear-gradient-69);}.cls-79{fill:url(#linear-gradient-70);}.cls-80{fill:url(#linear-gradient-71);}.cls-81{fill:url(#linear-gradient-72);}.cls-82{fill:url(#linear-gradient-73);}.cls-83{fill:url(#linear-gradient-74);}.cls-84{fill:url(#linear-gradient-75);}.cls-85{fill:url(#linear-gradient-76);}.cls-86{fill:url(#linear-gradient-77);}.cls-87{fill:url(#linear-gradient-78);}.cls-88{fill:url(#linear-gradient-79);}.cls-89{fill:url(#linear-gradient-80);}.cls-90{fill:url(#linear-gradient-81);}.cls-91{fill:url(#linear-gradient-82);}.cls-92{fill:url(#linear-gradient-83);}.cls-93{fill:url(#linear-gradient-84);}.cls-94{fill:url(#linear-gradient-85);}.cls-95{fill:url(#linear-gradient-86);}.cls-96{fill:url(#linear-gradient-87);}.cls-97{fill:url(#linear-gradient-88);}.cls-98{fill:url(#linear-gradient-89);}.cls-99{fill:url(#linear-gradient-90);}.cls-100{fill:url(#linear-gradient-91);}.cls-101{fill:url(#linear-gradient-92);}.cls-102{fill:url(#linear-gradient-93);}.cls-103{fill:url(#linear-gradient-94);}.cls-104{fill:url(#linear-gradient-95);}.cls-105{fill:url(#linear-gradient-96);}.cls-106{fill:url(#linear-gradient-97);}.cls-107{fill:url(#linear-gradient-98);}.cls-108{fill:url(#linear-gradient-99);}.cls-109{fill:url(#linear-gradient-100);}.cls-110{fill:url(#linear-gradient-101);}.cls-111{fill:url(#linear-gradient-102);}.cls-112{fill:url(#linear-gradient-103);}.cls-113{fill:url(#linear-gradient-104);}.cls-114{fill:url(#linear-gradient-105);}.cls-116{fill:#cfd1d2;}.cls-117{fill:url(#linear-gradient-106);}.cls-118{fill:url(#linear-gradient-107);}.cls-119{fill:url(#linear-gradient-108);}.cls-120{fill:url(#linear-gradient-109);}.cls-121{fill:url(#linear-gradient-110);}.cls-122{fill:url(#linear-gradient-111);}.cls-123{fill:url(#linear-gradient-112);}.cls-124{fill:url(#linear-gradient-113);}.cls-125{fill:url(#linear-gradient-114);}.cls-126{fill:url(#linear-gradient-115);}.cls-127{fill:url(#linear-gradient-116);}.cls-128{fill:url(#linear-gradient-117);}.cls-129{fill:url(#linear-gradient-118);}.cls-130{fill:url(#linear-gradient-119);}.cls-131{fill:url(#linear-gradient-120);}.cls-132{fill:url(#linear-gradient-121);}.cls-133{fill:url(#linear-gradient-122);}.cls-134{fill:url(#linear-gradient-123);}.cls-135{fill:url(#linear-gradient-124);}.cls-136{fill:url(#linear-gradient-125);}.cls-137{fill:url(#linear-gradient-126);}.cls-138{fill:url(#linear-gradient-127);}.cls-139{fill:url(#linear-gradient-128);}.cls-140{fill:url(#linear-gradient-129);}.cls-141{fill:url(#linear-gradient-130);}.cls-142{fill:url(#linear-gradient-131);}.cls-143{fill:url(#linear-gradient-132);}.cls-144{fill:url(#linear-gradient-133);}.cls-145{fill:url(#linear-gradient-134);}.cls-146{fill:url(#linear-gradient-135);}.cls-147{fill:url(#linear-gradient-136);}.cls-148{fill:url(#linear-gradient-137);}.cls-149{fill:url(#linear-gradient-138);}.cls-150{fill:url(#linear-gradient-139);}.cls-151{fill:url(#linear-gradient-140);}.cls-152{fill:url(#linear-gradient-141);}.cls-153{fill:url(#linear-gradient-142);}.cls-154{fill:url(#linear-gradient-143);}.cls-155{fill:url(#linear-gradient-144);}.cls-156{fill:url(#linear-gradient-145);}.cls-157{clip-path:url(#clip-path-2);}.cls-158{fill:url(#linear-gradient-146);}.cls-159{fill:url(#linear-gradient-147);}.cls-160{fill:url(#linear-gradient-148);}.cls-161{fill:url(#linear-gradient-149);}.cls-162{fill:url(#linear-gradient-150);}.cls-163{fill:url(#linear-gradient-151);}.cls-164{fill:url(#linear-gradient-152);}.cls-165{fill:url(#linear-gradient-153);}.cls-166{fill:url(#linear-gradient-154);}.cls-167{fill:url(#linear-gradient-155);}.cls-168{fill:url(#linear-gradient-156);}.cls-169{fill:url(#linear-gradient-157);}.cls-170{fill:url(#linear-gradient-158);}.cls-171{fill:url(#linear-gradient-159);}.cls-172{fill:url(#linear-gradient-160);}.cls-173{fill:url(#linear-gradient-161);}.cls-174{fill:url(#linear-gradient-162);}.cls-175{fill:url(#linear-gradient-163);}.cls-176{fill:url(#linear-gradient-164);}.cls-177{fill:url(#linear-gradient-165);}.cls-178{fill:url(#linear-gradient-166);}.cls-179{fill:url(#linear-gradient-167);}.cls-180{fill:url(#linear-gradient-168);}.cls-181{fill:url(#linear-gradient-169);}.cls-182{fill:url(#linear-gradient-170);}.cls-183{fill:url(#linear-gradient-171);}.cls-184{fill:url(#linear-gradient-172);}.cls-185{fill:url(#linear-gradient-173);}.cls-186{fill:url(#linear-gradient-174);}.cls-187{fill:url(#linear-gradient-175);}.cls-188{fill:url(#linear-gradient-176);}.cls-189{fill:url(#linear-gradient-177);}.cls-190{fill:url(#linear-gradient-178);}.cls-191{fill:url(#linear-gradient-179);}.cls-192{fill:url(#linear-gradient-180);}.cls-193{fill:url(#linear-gradient-181);}.cls-194{fill:url(#linear-gradient-182);}.cls-195{fill:url(#linear-gradient-183);}.cls-196{fill:url(#linear-gradient-184);}.cls-197{fill:url(#linear-gradient-185);}.cls-198{fill:url(#linear-gradient-186);}.cls-199{fill:url(#linear-gradient-187);}.cls-200{fill:url(#linear-gradient-188);}.cls-201{fill:url(#linear-gradient-189);}.cls-202{fill:url(#linear-gradient-190);}.cls-203{fill:url(#linear-gradient-191);}.cls-204{fill:url(#linear-gradient-192);}.cls-205{fill:url(#linear-gradient-193);}.cls-206{fill:url(#linear-gradient-194);}.cls-207{fill:url(#linear-gradient-195);}.cls-208{fill:url(#linear-gradient-196);}.cls-209{fill:url(#linear-gradient-197);}.cls-210{fill:url(#linear-gradient-198);}.cls-211{fill:url(#linear-gradient-199);}.cls-212{fill:url(#linear-gradient-200);}.cls-213{fill:url(#linear-gradient-201);}.cls-214{fill:url(#linear-gradient-202);}.cls-215{fill:url(#linear-gradient-203);}.cls-216{fill:url(#linear-gradient-204);}.cls-217{fill:url(#linear-gradient-205);}.cls-218{fill:url(#linear-gradient-206);}.cls-219{fill:url(#linear-gradient-207);}.cls-220{fill:url(#linear-gradient-208);}.cls-221{fill:url(#linear-gradient-209);}.cls-222{fill:url(#linear-gradient-210);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 98.42,
    y1: 90.05,
    x2: 81.17,
    y2: 121.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec61b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 107.57,
    y1: 84.81,
    x2: 61.79,
    y2: 141.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee492f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94070a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 82.73,
    y1: 92.51,
    x2: 115.79,
    y2: 92.51,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 506.28,
    y1: -39.86,
    x2: 532.28,
    y2: -70.19,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 506.6,
    y1: -39.58,
    x2: 532.6,
    y2: -69.92,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 506.92,
    y1: -39.31,
    x2: 532.92,
    y2: -69.64,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 507.24,
    y1: -39.03,
    x2: 533.24,
    y2: -69.37,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 507.56,
    y1: -38.76,
    x2: 533.56,
    y2: -69.09,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 507.88,
    y1: -38.48,
    x2: 533.88,
    y2: -68.82,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 503.97,
    y1: -44.84,
    x2: 529.97,
    y2: -75.17,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 504.29,
    y1: -44.56,
    x2: 530.29,
    y2: -74.9,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 504.61,
    y1: -44.29,
    x2: 530.61,
    y2: -74.62,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 504.93,
    y1: -44.01,
    x2: 530.93,
    y2: -74.35,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 505.26,
    y1: -43.74,
    x2: 531.26,
    y2: -74.07,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 505.58,
    y1: -43.46,
    x2: 531.58,
    y2: -73.8,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 528.31,
    y1: -45.81,
    x2: 537.97,
    y2: -63.97,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 527.82,
    y1: -46.07,
    x2: 537.48,
    y2: -64.23,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 527.33,
    y1: -46.33,
    x2: 536.99,
    y2: -64.5,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 526.83,
    y1: -46.59,
    x2: 536.5,
    y2: -64.76,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 526.34,
    y1: -46.85,
    x2: 536.01,
    y2: -65.02,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 525.85,
    y1: -47.12,
    x2: 535.51,
    y2: -65.28,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 525.77,
    y1: -35.73,
    x2: 537.6,
    y2: -53.23,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 525.69,
    y1: -35.78,
    x2: 537.53,
    y2: -53.28,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 525.62,
    y1: -35.83,
    x2: 537.46,
    y2: -53.33,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 525.55,
    y1: -35.88,
    x2: 537.38,
    y2: -53.38,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 525.48,
    y1: -35.93,
    x2: 537.31,
    y2: -53.43,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 525.41,
    y1: -35.98,
    x2: 537.24,
    y2: -53.47,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 533.05,
    y1: -36.68,
    x2: 544.89,
    y2: -54.18,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 532.98,
    y1: -36.73,
    x2: 544.81,
    y2: -54.23,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 532.91,
    y1: -36.77,
    x2: 544.74,
    y2: -54.27,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 532.84,
    y1: -36.82,
    x2: 544.67,
    y2: -54.32,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 532.77,
    y1: -36.87,
    x2: 544.6,
    y2: -54.37,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 532.69,
    y1: -36.92,
    x2: 544.53,
    y2: -54.42,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 512.8,
    y1: -40.56,
    x2: 538.8,
    y2: -70.89,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 513.12,
    y1: -40.28,
    x2: 539.12,
    y2: -70.62,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 513.44,
    y1: -40.01,
    x2: 539.44,
    y2: -70.34,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 513.76,
    y1: -39.73,
    x2: 539.76,
    y2: -70.07,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 514.08,
    y1: -39.46,
    x2: 540.08,
    y2: -69.79,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 514.4,
    y1: -39.18,
    x2: 540.4,
    y2: -69.52,
    gradientTransform: "translate(604.3 40.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 65.51,
    y1: 105.23,
    x2: 6.51,
    y2: 133.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "82.83 109.09 53.42 93.24 32.84 122.33 76.68 117.67 82.66 109.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 45.9,
    y1: 92.74,
    x2: 78.56,
    y2: 123.57,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 49.01,
    y1: 89.44,
    x2: 81.67,
    y2: 120.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 39.68,
    y1: 99.32,
    x2: 72.34,
    y2: 130.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 42.79,
    y1: 96.03,
    x2: 75.45,
    y2: 126.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 58.28,
    y1: 79.62,
    x2: 90.95,
    y2: 110.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 61.39,
    y1: 76.32,
    x2: 94.06,
    y2: 107.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 52.07,
    y1: 86.2,
    x2: 84.73,
    y2: 117.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 55.17,
    y1: 82.91,
    x2: 87.84,
    y2: 113.74,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 56.25,
    y1: 81.76,
    x2: 88.92,
    y2: 112.6,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 53.15,
    y1: 85.05,
    x2: 85.82,
    y2: 115.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 62.47,
    y1: 75.18,
    x2: 95.14,
    y2: 106.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 59.36,
    y1: 78.47,
    x2: 92.03,
    y2: 109.3,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 43.87,
    y1: 94.88,
    x2: 76.54,
    y2: 125.72,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 40.76,
    y1: 98.18,
    x2: 73.43,
    y2: 129.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 50.09,
    y1: 88.3,
    x2: 82.75,
    y2: 119.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 46.98,
    y1: 91.59,
    x2: 79.64,
    y2: 122.42,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 41.19,
    y1: 97.73,
    x2: 73.85,
    y2: 128.56,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 44.29,
    y1: 94.44,
    x2: 76.96,
    y2: 125.27,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 34.97,
    y1: 104.31,
    x2: 67.64,
    y2: 135.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 38.08,
    y1: 101.02,
    x2: 70.75,
    y2: 131.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 53.57,
    y1: 84.61,
    x2: 86.24,
    y2: 115.44,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 56.68,
    y1: 81.32,
    x2: 89.35,
    y2: 112.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 47.35,
    y1: 91.19,
    x2: 80.02,
    y2: 122.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 50.46,
    y1: 87.9,
    x2: 83.13,
    y2: 118.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 51.54,
    y1: 86.75,
    x2: 84.21,
    y2: 117.59,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 48.44,
    y1: 90.05,
    x2: 81.1,
    y2: 120.88,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 57.76,
    y1: 80.17,
    x2: 90.43,
    y2: 111,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 54.65,
    y1: 83.46,
    x2: 87.32,
    y2: 114.29,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 39.16,
    y1: 99.88,
    x2: 71.83,
    y2: 130.71,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 36.05,
    y1: 103.17,
    x2: 68.72,
    y2: 134,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 45.37,
    y1: 93.29,
    x2: 78.04,
    y2: 124.12,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 42.27,
    y1: 96.58,
    x2: 74.93,
    y2: 127.42,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 36.48,
    y1: 102.72,
    x2: 69.14,
    y2: 133.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 39.58,
    y1: 99.42,
    x2: 72.25,
    y2: 130.26,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 30.26,
    y1: 109.31,
    x2: 62.92,
    y2: 140.14,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 33.37,
    y1: 106.01,
    x2: 66.04,
    y2: 136.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 48.86,
    y1: 89.6,
    x2: 81.52,
    y2: 120.43,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 51.97,
    y1: 86.31,
    x2: 84.63,
    y2: 117.14,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 42.64,
    y1: 96.19,
    x2: 75.31,
    y2: 127.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 45.75,
    y1: 92.89,
    x2: 78.42,
    y2: 123.72,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 46.83,
    y1: 91.75,
    x2: 79.5,
    y2: 122.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 43.72,
    y1: 95.04,
    x2: 76.39,
    y2: 125.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 53.05,
    y1: 85.16,
    x2: 85.71,
    y2: 115.99,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 49.95,
    y1: 88.46,
    x2: 82.6,
    y2: 119.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 34.45,
    y1: 104.87,
    x2: 67.12,
    y2: 135.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 31.34,
    y1: 108.16,
    x2: 64,
    y2: 138.99,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 40.66,
    y1: 98.28,
    x2: 73.33,
    y2: 129.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 37.55,
    y1: 101.57,
    x2: 70.22,
    y2: 132.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 31.76,
    y1: 107.71,
    x2: 64.43,
    y2: 138.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 34.87,
    y1: 104.42,
    x2: 67.54,
    y2: 135.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 25.55,
    y1: 114.3,
    x2: 58.21,
    y2: 145.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 28.65,
    y1: 111,
    x2: 61.32,
    y2: 141.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 44.15,
    y1: 94.6,
    x2: 76.81,
    y2: 125.42,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 47.26,
    y1: 91.3,
    x2: 79.92,
    y2: 122.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 37.93,
    y1: 101.18,
    x2: 70.6,
    y2: 132.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 41.04,
    y1: 97.89,
    x2: 73.71,
    y2: 128.72,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 42.12,
    y1: 96.74,
    x2: 74.79,
    y2: 127.57,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 39.01,
    y1: 100.03,
    x2: 71.68,
    y2: 130.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 48.34,
    y1: 90.15,
    x2: 81,
    y2: 120.99,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 45.23,
    y1: 93.45,
    x2: 77.89,
    y2: 124.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 29.74,
    y1: 109.86,
    x2: 62.4,
    y2: 140.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 26.63,
    y1: 113.15,
    x2: 59.29,
    y2: 143.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 35.95,
    y1: 103.27,
    x2: 68.62,
    y2: 134.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 32.84,
    y1: 106.57,
    x2: 65.51,
    y2: 137.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 32.91,
    y1: 107.73,
    x2: 57.43,
    y2: 107.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 541.5,
    y1: -71.29,
    x2: 524.25,
    y2: -39.79,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 550.65,
    y1: -76.54,
    x2: 504.87,
    y2: -20.25,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 525.81,
    y1: -68.84,
    x2: 558.87,
    y2: -68.84,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 63.2,
    y1: 121.49,
    x2: 89.2,
    y2: 91.15,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 63.52,
    y1: 121.76,
    x2: 89.52,
    y2: 91.43,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 63.84,
    y1: 122.04,
    x2: 89.84,
    y2: 91.7,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 64.16,
    y1: 122.31,
    x2: 90.16,
    y2: 91.98,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 64.48,
    y1: 122.59,
    x2: 90.48,
    y2: 92.25,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 64.8,
    y1: 122.86,
    x2: 90.8,
    y2: 92.53,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 60.89,
    y1: 116.51,
    x2: 86.89,
    y2: 86.17,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 61.21,
    y1: 116.78,
    x2: 87.21,
    y2: 86.45,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 61.53,
    y1: 117.06,
    x2: 87.53,
    y2: 86.72,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 61.85,
    y1: 117.33,
    x2: 87.85,
    y2: 87,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 62.17,
    y1: 117.61,
    x2: 88.17,
    y2: 87.27,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 62.49,
    y1: 117.88,
    x2: 88.49,
    y2: 87.55,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 85.23,
    y1: 115.54,
    x2: 94.89,
    y2: 97.37,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 84.73,
    y1: 115.28,
    x2: 94.4,
    y2: 97.11,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 84.24,
    y1: 115.02,
    x2: 93.91,
    y2: 96.85,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 83.75,
    y1: 114.75,
    x2: 93.42,
    y2: 96.59,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 83.26,
    y1: 114.49,
    x2: 92.93,
    y2: 96.33,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 82.77,
    y1: 114.23,
    x2: 92.43,
    y2: 96.06,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 82.68,
    y1: 125.61,
    x2: 94.52,
    y2: 108.11,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 82.61,
    y1: 125.56,
    x2: 94.44,
    y2: 108.06,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 82.54,
    y1: 125.52,
    x2: 94.37,
    y2: 108.02,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 82.47,
    y1: 125.47,
    x2: 94.3,
    y2: 107.97,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 82.4,
    y1: 125.42,
    x2: 94.23,
    y2: 107.92,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 82.33,
    y1: 125.37,
    x2: 94.16,
    y2: 107.87,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 89.97,
    y1: 124.67,
    x2: 101.8,
    y2: 107.17,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 89.9,
    y1: 124.62,
    x2: 101.73,
    y2: 107.12,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 89.83,
    y1: 124.57,
    x2: 101.66,
    y2: 107.07,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 89.76,
    y1: 124.52,
    x2: 101.59,
    y2: 107.02,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 89.68,
    y1: 124.47,
    x2: 101.52,
    y2: 106.97,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 89.61,
    y1: 124.43,
    x2: 101.45,
    y2: 106.93,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 69.71,
    y1: 120.79,
    x2: 95.71,
    y2: 90.45,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 70.04,
    y1: 121.06,
    x2: 96.04,
    y2: 90.73,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 70.36,
    y1: 121.34,
    x2: 96.36,
    y2: 91,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 70.68,
    y1: 121.61,
    x2: 96.68,
    y2: 91.28,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 71,
    y1: 121.89,
    x2: 97,
    y2: 91.55,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 71.32,
    y1: 122.16,
    x2: 97.32,
    y2: 91.83,
    gradientTransform: "translate(4.98 31.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 508.59,
    y1: -56.11,
    x2: 449.59,
    y2: -28.11,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "83.38 124.57 112.79 140.43 133.37 111.33 89.53 115.99 83.55 123.76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 488.98,
    y1: -68.61,
    x2: 521.64,
    y2: -37.78,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 492.09,
    y1: -71.9,
    x2: 524.75,
    y2: -41.07,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 482.76,
    y1: -62.02,
    x2: 515.42,
    y2: -31.2,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 485.87,
    y1: -65.32,
    x2: 518.54,
    y2: -34.49,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 501.37,
    y1: -81.73,
    x2: 534.03,
    y2: -50.9,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 504.47,
    y1: -85.02,
    x2: 537.14,
    y2: -54.19,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 495.15,
    y1: -75.14,
    x2: 527.81,
    y2: -44.31,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 498.26,
    y1: -78.44,
    x2: 530.92,
    y2: -47.6,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 499.34,
    y1: -79.58,
    x2: 532,
    y2: -48.75,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 496.23,
    y1: -76.29,
    x2: 528.9,
    y2: -45.45,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 505.55,
    y1: -86.17,
    x2: 538.22,
    y2: -55.34,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 502.45,
    y1: -82.87,
    x2: 535.11,
    y2: -52.04,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 486.95,
    y1: -66.46,
    x2: 519.62,
    y2: -35.63,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 483.84,
    y1: -63.17,
    x2: 516.51,
    y2: -32.34,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 493.17,
    y1: -73.05,
    x2: 525.83,
    y2: -42.21,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 490.06,
    y1: -69.75,
    x2: 522.73,
    y2: -38.92,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 484.27,
    y1: -63.62,
    x2: 516.93,
    y2: -32.79,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 487.38,
    y1: -66.91,
    x2: 520.04,
    y2: -36.08,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 478.05,
    y1: -57.03,
    x2: 510.72,
    y2: -26.2,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 481.16,
    y1: -60.33,
    x2: 513.83,
    y2: -29.49,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 496.66,
    y1: -76.73,
    x2: 529.32,
    y2: -45.91,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 499.76,
    y1: -80.03,
    x2: 532.43,
    y2: -49.2,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 490.44,
    y1: -70.15,
    x2: 523.1,
    y2: -39.32,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 493.55,
    y1: -73.44,
    x2: 526.21,
    y2: -42.61,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 494.63,
    y1: -74.59,
    x2: 527.29,
    y2: -43.76,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 491.52,
    y1: -71.3,
    x2: 524.18,
    y2: -40.47,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 500.84,
    y1: -81.18,
    x2: 533.51,
    y2: -50.34,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 497.74,
    y1: -77.88,
    x2: 530.4,
    y2: -47.05,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 482.24,
    y1: -61.47,
    x2: 514.91,
    y2: -30.64,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 479.13,
    y1: -58.18,
    x2: 511.8,
    y2: -27.35,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 488.46,
    y1: -68.06,
    x2: 521.12,
    y2: -37.22,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 485.35,
    y1: -64.76,
    x2: 518.02,
    y2: -33.93,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 479.56,
    y1: -58.62,
    x2: 512.22,
    y2: -27.79,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 482.66,
    y1: -61.92,
    x2: 515.33,
    y2: -31.08,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 473.34,
    y1: -52.04,
    x2: 506.01,
    y2: -21.21,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 476.45,
    y1: -55.33,
    x2: 509.12,
    y2: -24.5,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 491.95,
    y1: -71.74,
    x2: 524.61,
    y2: -40.91,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 495.05,
    y1: -75.04,
    x2: 527.72,
    y2: -44.21,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 485.73,
    y1: -65.16,
    x2: 518.39,
    y2: -34.33,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 488.84,
    y1: -68.45,
    x2: 521.5,
    y2: -37.62,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 489.91,
    y1: -69.6,
    x2: 522.58,
    y2: -38.77,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 486.81,
    y1: -66.31,
    x2: 519.47,
    y2: -35.47,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 496.13,
    y1: -76.19,
    x2: 528.8,
    y2: -45.35,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 493.03,
    y1: -72.89,
    x2: 525.69,
    y2: -42.06,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 477.53,
    y1: -56.48,
    x2: 510.2,
    y2: -25.64,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 474.42,
    y1: -53.19,
    x2: 507.09,
    y2: -22.35,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 483.75,
    y1: -63.06,
    x2: 516.41,
    y2: -32.23,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 480.64,
    y1: -59.77,
    x2: 513.3,
    y2: -28.94,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 474.85,
    y1: -53.63,
    x2: 507.51,
    y2: -22.8,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 477.95,
    y1: -56.93,
    x2: 510.62,
    y2: -26.09,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 468.63,
    y1: -47.05,
    x2: 501.3,
    y2: -16.22,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 471.74,
    y1: -50.34,
    x2: 504.41,
    y2: -19.51,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 487.23,
    y1: -66.75,
    x2: 519.9,
    y2: -35.92,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 490.34,
    y1: -70.05,
    x2: 523,
    y2: -39.22,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 481.01,
    y1: -60.17,
    x2: 513.68,
    y2: -29.34,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 484.12,
    y1: -63.46,
    x2: 516.79,
    y2: -32.63,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 485.2,
    y1: -64.61,
    x2: 517.87,
    y2: -33.78,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 482.09,
    y1: -61.32,
    x2: 514.76,
    y2: -30.48,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 491.42,
    y1: -71.19,
    x2: 524.09,
    y2: -40.36,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 488.31,
    y1: -67.9,
    x2: 520.98,
    y2: -37.07,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 472.82,
    y1: -51.49,
    x2: 505.49,
    y2: -20.65,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 469.71,
    y1: -48.19,
    x2: 502.38,
    y2: -17.36,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 479.03,
    y1: -58.07,
    x2: 511.7,
    y2: -27.24,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 475.93,
    y1: -54.78,
    x2: 508.59,
    y2: -23.95,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 475.99,
    y1: -53.61,
    x2: 500.51,
    y2: -53.61,
    gradientTransform: "translate(609.29 72.32) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1572.67,
    y: -743.25,
    width: 2406.31,
    height: 1210.9
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 153,
    height: 217,
    transform: "translate(6.79 8.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAADZCAYAAAAzBJLWAAAACXBIWXMAAAsSAAALEgHS3X78AAACc0lEQVR4Xu3WO47DMBQEwUfB978yN7Ih7wcLw2pHVRElMWwMtPbe882PF/CidX44Tuc9AuMaTx2dI4MrPUK7R2bBKOwZS8YHHGPFaG1LRk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5ERGTmTkREZOZORERk5k5I6ZWf9dgjcsS0buHpk1o7Bmnv/JhMaVHj3d/viwB17361B9AbfaDrCvFcmlAAAAAElFTkSuQmCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.41,20.07v-.6h9.37v.6H30a2.31,2.31,0,0,0-1.95.78,4.93,4.93,0,0,0-.39,2.49V34a12.3,12.3,0,0,1-.54,4,6.24,6.24,0,0,1-1.86,2.67,4.74,4.74,0,0,1-3.2,1.13,3.52,3.52,0,0,1-2.38-.75,2.22,2.22,0,0,1-.87-1.71,1.63,1.63,0,0,1,.4-1.2,1.76,1.76,0,0,1,1.24-.5,1.48,1.48,0,0,1,.93.34,5.61,5.61,0,0,1,1,1.81c.25.58.56.87.95.87a1,1,0,0,0,.81-.53,3.38,3.38,0,0,0,.38-1.89V23.34a7.17,7.17,0,0,0-.21-2.19,1.44,1.44,0,0,0-.67-.7,3,3,0,0,0-1.47-.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.08,212.66v.6h-9.37v-.6h.79a2.28,2.28,0,0,0,1.95-.79,4.86,4.86,0,0,0,.39-2.48V198.7a12.26,12.26,0,0,1,.54-4,6.24,6.24,0,0,1,1.86-2.67,4.75,4.75,0,0,1,3.2-1.14,3.52,3.52,0,0,1,2.38.75,2.24,2.24,0,0,1,.87,1.72,1.59,1.59,0,0,1-.4,1.19,1.72,1.72,0,0,1-1.24.5,1.47,1.47,0,0,1-.93-.33,5.61,5.61,0,0,1-1-1.81c-.24-.58-.56-.87-1-.87a1,1,0,0,0-.81.53,3.38,3.38,0,0,0-.38,1.89v14.93a7.17,7.17,0,0,0,.21,2.19,1.44,1.44,0,0,0,.67.7,3,3,0,0,0,1.47.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.94,43.28s-6.42,3.14-6.42,8a2.86,2.86,0,0,0,5.33,1.42,2.07,2.07,0,0,0-.29-2.4s1.58.63.94,3.91c-.09.49-.21,1.06-.38,1.71h1.64c-.17-.65-.29-1.22-.38-1.71-.64-3.28.94-3.91.94-3.91a2.05,2.05,0,0,0-.28,2.4,2.85,2.85,0,0,0,5.32-1.42C30.36,46.42,23.94,43.28,23.94,43.28Z"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 11,
    transform: "translate(17.79 43.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAALCAYAAACksgdhAAAACXBIWXMAAAsSAAALEgHS3X78AAABKElEQVQoU22PzWobQRCEv54f7xqbIPQCXiE5QsEHG+f9HyA4byCQbgkKiYOMtavVzFQORmtFSUEfuprqqjJJnGPWTASwXK/snyNg56K7xSdVdU1V1Wy+f+N/Yne6PN4/KISI9wEA7z3m3OB8xOC0+DjXaDymuqjIpRBioO/2/PyxIZeCShkcHcB8ditJGEaRcM6hImKMfBiNCN4D713DrJno6vr6LZLBoe8xZ3jnkcRFVTMae162W7q2ZXDadx1SIfUHjnHb3Q5JtLtXcs6YvdcPAOYcKWVihJQOPH35agCfHx7V73ukQs6Z+vKSWTPRIJcKXdfyst0OH38//8LMkEROia5tWa5XFuCtBzGSzcgpcYpD31NK+YtDEpKY3jSa3jQ67qdzzv8BjJC1fOUB3YwAAAAASUVORK5CYII="
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.55,189.45s6.42-3.14,6.42-8a2.86,2.86,0,0,0-5.33-1.43,2.07,2.07,0,0,0,.29,2.4s-1.58-.62-.94-3.91c.09-.48.21-1.05.38-1.7h-1.64c.17.65.29,1.22.38,1.7.64,3.29-.94,3.91-.94,3.91a2.07,2.07,0,0,0,.29-2.4,2.86,2.86,0,0,0-5.33,1.43C136.13,186.31,142.55,189.45,142.55,189.45Z"
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 10,
    transform: "translate(135.79 179.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKCAYAAABv7tTEAAAACXBIWXMAAAsSAAALEgHS3X78AAABEUlEQVQoU2WRS26DUAxFj9/jAeHTNSRt2nHb/W+kShqygbYTSICA3QGBRIolS5al+7GvmBkA2/VmGoD9sRLuarvemHMOVWV/rETM7Lr0RCFCROjadgG+vWwthAAGXdcCEM0st/YU5dOikuU5GMyO+r7DAagqqyybQN4RQgDg8/3D0jQljmMQEDe5XuzlRUG6WqGqJEkKIpgqAMMw0LVnVI2uPRPNNpq6RsRRlCXOe0wVH0WoKd48BpxPDbvqIA5u32qamr7vcSJEIYAI3vlJ7XKZ+W9KAKbK3+8PmJE/lYzDQFPXRCGgquyqg8D1pvt63TxbnCR47xnHkThOODU1X9/7JbsH0Aw0M7I859Q0D2H/A64JitqwCjIyAAAAAElFTkSuQmCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73,33.14s-14.8-15.82,12.8-15.26a47.75,47.75,0,0,1,18.75,4.5s18.74-.79,8.81,9.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.59,34.91s-23.49-1.18-39.24,1l-.83-3.15A268.82,268.82,0,0,1,113,31.47Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.65,72.62,128,78s5.61.53,5.61,7.23v25.72L34,122.45S59.15,84.94,67,78.24c.88-.75,4.92-1.63,9.88-2.48C86.51,74.11,99.65,72.62,99.65,72.62Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.45,34.6,73.71,36.17l.52,2.19L71.74,52.12l2.7.72L74.06,56l2.3,1.47-.18,1.78s2.55,1.07,1.06,2.57-2.79,4.4,4.3,4.8c4.33.24,6.53,2.25,2.91,8.44,0-.58,3,4,7.66,4.3,7.17.41,17.14-3.21,17.14-3.21S93.79,40.34,93.45,34.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.71,38.68A2.3,2.3,0,0,0,76,41.6a12,12,0,0,0,2.75-.84c1.63-.66,5.17-.22,5.65.35s-1-3.29-6.62-1.61C74.26,40.53,74.71,38.68,74.71,38.68Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.67,43.09A6,6,0,0,0,78.94,43c1.61-.55,3.84-.43,4.92.58a9.13,9.13,0,0,0-4.3.27s.56,2-.66,2.2-1.3-2-1.3-2A3.15,3.15,0,0,1,75.67,43.09Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89.9,34.5s-3,3.94-1.75,5.75C92,46.13,90.84,54.08,89,63c0,0-6.23,14.21,26.3,8.63,0,0-4.64-3.61-2.93-14.37.91-5.72,3.88-23-1-22.25Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.46,74.9l-38.57,43,56.74-7V81.32A11.64,11.64,0,0,0,128,78C124.76,77.31,115.46,74.9,115.46,74.9Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "114.65 74.78 75.31 117.95 83.76 117.09 120.11 75.9 114.65 74.78"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M129.2,78.11s4.43.8,4.43,3.21l-26.82,32.75-7.76,1Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "114.44 74.73 115.78 79.61 107.74 82.47 106.55 89.93 98.96 92.1 98.36 99.3 90.62 101.33 89.13 109.48 82.73 110.29 114.44 74.73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.72,33l.76,3.2s21.93-2,39.48-1c1,.05-.23-.26-.23-.26s-20.79-1.19-38.52.21C74.21,35.11,73.46,35,72.72,33Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119 75.84 120.31 76.17 83.74 117.09 81.9 117.67 119 75.84"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.92,72,79.54,75S80.76,82,95,82.4c11.3.28,19.75-7.49,19.75-7.49l-6.29-1.24s-5.26,3.49-13.73,2.86C87.49,76,85.92,72,85.92,72Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M79.88,101.45s-2.46-.4-3.44,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.09.72.72,0,0,0,.4-.74s.33.49-.52,1.3c-.12.12-.27.26-.45.41l.47.33a4.46,4.46,0,0,1,.24-.56c.47-1.07,1-.93,1-.93a.74.74,0,0,0-.57.63,1,1,0,0,0,1.81.66C81.09,103.63,79.88,101.45,79.88,101.45Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M82.46,97.79s-2.46-.4-3.44,1a1,1,0,0,0,.24,1.38,1,1,0,0,0,1,.09.72.72,0,0,0,.4-.74s.32.5-.52,1.3c-.12.12-.27.26-.45.41l.47.33c.08-.22.16-.41.23-.56.48-1.07,1.05-.93,1.05-.93a.73.73,0,0,0-.56.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C83.66,100,82.46,97.79,82.46,97.79Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M85,94.13s-2.46-.39-3.45,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.08.74.74,0,0,0,.4-.74s.32.5-.52,1.3a4.8,4.8,0,0,1-.45.41l.47.33c.08-.22.16-.4.23-.56.47-1.06,1.05-.92,1.05-.92a.71.71,0,0,0-.56.62,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C86.24,96.32,85,94.13,85,94.13Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M87.61,90.48s-2.45-.4-3.44,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.08.71.71,0,0,0,.4-.74s.33.5-.52,1.31l-.44.41.46.32a5.22,5.22,0,0,1,.24-.56c.47-1.06,1-.92,1-.92a.71.71,0,0,0-.56.63,1,1,0,0,0,.41.9,1,1,0,0,0,1.39-.24C88.82,92.66,87.61,90.48,87.61,90.48Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M90.19,86.82s-2.45-.4-3.44,1A1,1,0,0,0,87,89.21a1,1,0,0,0,1,.09.72.72,0,0,0,.4-.74s.32.49-.52,1.3c-.12.12-.27.26-.45.41l.47.33c.08-.22.16-.41.23-.56.48-1.07,1.06-.93,1.06-.93a.73.73,0,0,0-.57.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C91.39,89,90.19,86.82,90.19,86.82Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M92.77,83.16s-2.46-.39-3.44,1a1,1,0,0,0,1.23,1.47.74.74,0,0,0,.4-.74s.32.49-.52,1.3a4.8,4.8,0,0,1-.45.41l.47.33c.08-.22.16-.4.23-.56.48-1.07,1.06-.93,1.06-.93a.73.73,0,0,0-.57.63,1,1,0,0,0,.42.9A1,1,0,0,0,93,86.74C94,85.34,92.77,83.16,92.77,83.16Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M86.36,101.56s-2.46-.39-3.44,1a1,1,0,0,0,.24,1.38,1,1,0,0,0,1,.09.72.72,0,0,0,.4-.74s.32.5-.52,1.31c-.12.12-.27.25-.45.4l.47.33c.08-.22.16-.4.23-.56.48-1.06,1-.92,1-.92a.71.71,0,0,0-.56.62,1,1,0,0,0,1.8.67C87.56,103.75,86.36,101.56,86.36,101.56Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M88.94,97.91s-2.46-.4-3.45,1a1,1,0,0,0,1.23,1.48.73.73,0,0,0,.41-.75s.32.5-.52,1.31c-.13.12-.27.26-.45.41l.46.33.24-.57c.48-1.06,1-.92,1-.92a.73.73,0,0,0-.56.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C90.14,100.09,88.94,97.91,88.94,97.91Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M91.52,94.25s-2.46-.39-3.45,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.09.71.71,0,0,0,.4-.74s.33.49-.51,1.3c-.13.12-.27.26-.45.41l.46.33c.09-.22.16-.41.24-.56.47-1.07,1-.93,1-.93a.72.72,0,0,0-.56.63,1,1,0,0,0,.41.9,1,1,0,0,0,1.39-.24C92.71,96.43,91.52,94.25,91.52,94.25Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M94.09,90.59s-2.46-.4-3.44,1A1,1,0,0,0,90.89,93a1,1,0,0,0,1,.09.72.72,0,0,0,.4-.74s.33.5-.52,1.3a4.8,4.8,0,0,1-.45.41l.47.33a5.22,5.22,0,0,1,.24-.56c.47-1.06,1-.93,1-.93a.74.74,0,0,0-.57.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C95.29,92.78,94.09,90.59,94.09,90.59Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M96.67,86.93s-2.46-.39-3.45,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.09.76.76,0,0,0,.4-.75s.32.5-.52,1.31c-.12.12-.27.25-.45.41l.47.33c.08-.23.16-.41.23-.57.48-1.06,1-.92,1-.92a.72.72,0,0,0-.56.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C97.87,89.12,96.67,86.93,96.67,86.93Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M99.25,83.28s-2.46-.4-3.45,1A1,1,0,0,0,97,85.76a.73.73,0,0,0,.41-.74s.32.49-.52,1.3c-.13.12-.27.26-.45.41l.46.33c.09-.22.16-.41.24-.56.48-1.07,1-.93,1-.93a.72.72,0,0,0-.56.63,1,1,0,0,0,1.8.66C100.45,85.46,99.25,83.28,99.25,83.28Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M69.86,98.9s-2.46-.4-3.44,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.09.73.73,0,0,0,.4-.75s.32.5-.52,1.31c-.12.12-.27.26-.45.41l.47.33c.08-.22.16-.41.23-.56.48-1.07,1-.93,1-.93a.73.73,0,0,0-.56.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C71.06,101.08,69.86,98.9,69.86,98.9Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M72.44,95.24s-2.46-.4-3.45,1a1,1,0,0,0,1.23,1.47.73.73,0,0,0,.41-.74s.32.49-.52,1.3c-.13.12-.27.26-.45.41l.46.33c.09-.22.17-.41.24-.56.48-1.07,1-.93,1-.93a.73.73,0,0,0-.56.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C73.64,97.42,72.44,95.24,72.44,95.24Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M75,91.58s-2.46-.39-3.45,1A1,1,0,0,0,71.81,94a1,1,0,0,0,1,.09.71.71,0,0,0,.4-.74s.33.5-.51,1.3c-.13.13-.27.26-.45.41l.46.33c.09-.22.16-.4.24-.56.47-1.07,1-.93,1-.93a.72.72,0,0,0-.56.63,1,1,0,0,0,.41.9,1,1,0,0,0,1.39-.24C76.21,93.76,75,91.58,75,91.58Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M77.59,87.92s-2.46-.39-3.44,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.08.71.71,0,0,0,.4-.74s.33.5-.52,1.31c-.12.12-.27.25-.45.41l.47.32a5.22,5.22,0,0,1,.24-.56c.47-1.06,1-.92,1-.92a.73.73,0,0,0-.57.63,1,1,0,0,0,1.8.66C78.79,90.11,77.59,87.92,77.59,87.92Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M80.17,84.27s-2.46-.4-3.45,1A1,1,0,0,0,77,86.66a1,1,0,0,0,1,.09.74.74,0,0,0,.4-.74s.32.49-.52,1.3c-.12.12-.27.26-.45.41l.47.33c.08-.22.16-.41.23-.56.48-1.07,1-.93,1-.93a.73.73,0,0,0-.56.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C81.37,86.45,80.17,84.27,80.17,84.27Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M82.75,80.61s-2.46-.39-3.45,1A1,1,0,0,0,79.54,83a1,1,0,0,0,1,.09.73.73,0,0,0,.41-.74s.32.49-.52,1.3c-.13.13-.27.26-.45.41l.46.33c.09-.22.16-.4.24-.56.48-1.07,1-.93,1-.93a.72.72,0,0,0-.56.63,1,1,0,0,0,1.8.66C84,82.79,82.75,80.61,82.75,80.61Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M65.91,95.33s-2.46-.39-3.45,1a1,1,0,0,0,1.23,1.47.71.71,0,0,0,.4-.74s.33.5-.51,1.3c-.12.12-.27.26-.45.41l.46.33c.09-.22.16-.4.24-.56.48-1.07,1-.92,1-.92a.71.71,0,0,0-.56.62,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.23C67.11,97.52,65.91,95.33,65.91,95.33Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M68.49,91.67s-2.46-.39-3.45,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.08.7.7,0,0,0,.4-.74s.33.5-.51,1.3c-.13.13-.27.27-.45.42l.46.32a5.22,5.22,0,0,1,.24-.56c.47-1.06,1-.92,1-.92a.71.71,0,0,0-.56.63,1,1,0,0,0,1.8.66C69.69,93.86,68.49,91.67,68.49,91.67Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M71.06,88s-2.45-.4-3.44,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.09.72.72,0,0,0,.4-.74s.33.49-.52,1.3c-.12.12-.27.26-.45.41l.47.33a4.46,4.46,0,0,1,.24-.56c.47-1.07,1.05-.93,1.05-.93a.7.7,0,0,0-.56.63,1,1,0,0,0,.41.9,1,1,0,0,0,1.38-.24C72.26,90.2,71.06,88,71.06,88Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M73.64,84.36s-2.46-.4-3.44,1a1,1,0,0,0,.24,1.38,1,1,0,0,0,1,.09.72.72,0,0,0,.4-.74s.32.49-.52,1.3c-.12.12-.27.26-.45.41l.47.33c.08-.22.16-.4.23-.56.48-1.07,1.06-.93,1.06-.93a.73.73,0,0,0-.57.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C74.84,86.54,73.64,84.36,73.64,84.36Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M76.22,80.7s-2.46-.39-3.45,1A1,1,0,0,0,73,83.09a1,1,0,0,0,1,.09.71.71,0,0,0,.4-.74s.33.5-.51,1.3c-.13.13-.27.26-.45.41l.46.33c.09-.22.17-.4.24-.56.48-1.06,1-.93,1-.93a.73.73,0,0,0-.56.63,1,1,0,0,0,.42.91,1,1,0,0,0,1.38-.24C77.42,82.89,76.22,80.7,76.22,80.7Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M78.8,77.05s-2.46-.4-3.45,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.09.71.71,0,0,0,.4-.75s.33.5-.52,1.31c-.12.12-.27.25-.45.41l.47.32c.09-.22.16-.4.24-.55.47-1.07,1-.93,1-.93a.72.72,0,0,0-.56.63,1,1,0,0,0,.41.9A1,1,0,0,0,79,80.63C80,79.23,78.8,77.05,78.8,77.05Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M58.62,96.28s-2.46-.4-3.44,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.09.72.72,0,0,0,.4-.74s.32.49-.52,1.3c-.12.12-.27.26-.45.41l.47.33c.08-.22.16-.41.23-.56.48-1.07,1.05-.93,1.05-.93a.73.73,0,0,0-.56.63,1,1,0,0,0,1.81.66C59.82,98.46,58.62,96.28,58.62,96.28Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M61.2,92.62s-2.46-.4-3.45,1A1,1,0,0,0,59,95.1a.74.74,0,0,0,.4-.74s.32.5-.52,1.3c-.12.12-.27.26-.45.41l.46.33c.09-.22.17-.41.24-.56.48-1.07,1.05-.93,1.05-.93a.73.73,0,0,0-.56.63,1,1,0,0,0,1.8.66C62.4,94.8,61.2,92.62,61.2,92.62Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M63.78,89s-2.46-.39-3.45,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.08.71.71,0,0,0,.4-.74s.33.5-.51,1.3c-.13.13-.27.26-.45.41l.46.33c.09-.22.16-.4.24-.56.47-1.06,1-.92,1-.92a.71.71,0,0,0-.56.62,1,1,0,0,0,.41.9A1,1,0,0,0,64,92.54C65,91.15,63.78,89,63.78,89Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M66.35,85.31s-2.45-.4-3.44,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.08.71.71,0,0,0,.4-.74s.33.5-.52,1.31l-.44.41.46.32a5.22,5.22,0,0,1,.24-.56c.47-1.06,1-.92,1-.92a.73.73,0,0,0-.57.63,1,1,0,0,0,1.81.66C67.55,87.49,66.35,85.31,66.35,85.31Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M68.93,81.65s-2.46-.4-3.44,1A1,1,0,0,0,65.73,84a1,1,0,0,0,1,.09.74.74,0,0,0,.4-.74s.32.49-.52,1.3c-.12.12-.27.26-.45.41l.47.33c.08-.22.16-.41.23-.56.48-1.07,1.06-.93,1.06-.93a.73.73,0,0,0-.57.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C70.13,83.83,68.93,81.65,68.93,81.65Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M71.51,78s-2.46-.39-3.45,1a1,1,0,0,0,.24,1.38,1,1,0,0,0,1,.09.73.73,0,0,0,.41-.74s.32.49-.52,1.3a4.8,4.8,0,0,1-.45.41l.46.33c.09-.22.16-.4.24-.56.48-1.07,1-.93,1-.93a.73.73,0,0,0-.56.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C72.71,80.17,71.51,78,71.51,78Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M74.51,100.81s-2.46-.39-3.45,1a1,1,0,0,0,.24,1.38,1,1,0,0,0,1,.09.71.71,0,0,0,.4-.74s.33.5-.51,1.31l-.45.4.46.33c.09-.22.16-.4.24-.56.48-1.06,1-.92,1-.92a.7.7,0,0,0-.56.62,1,1,0,0,0,1.8.67C75.71,103,74.51,100.81,74.51,100.81Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M77.09,97.16s-2.46-.4-3.45,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.09.73.73,0,0,0,.4-.75s.33.5-.52,1.31a4.91,4.91,0,0,1-.45.41l.47.33a5.46,5.46,0,0,1,.24-.57c.47-1.06,1-.92,1-.92a.72.72,0,0,0-.56.63,1,1,0,0,0,.41.9,1,1,0,0,0,1.39-.24C78.28,99.34,77.09,97.16,77.09,97.16Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M79.66,93.5s-2.46-.39-3.44,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.09.72.72,0,0,0,.4-.74s.32.49-.52,1.3c-.12.12-.27.26-.45.41l.47.33a4.46,4.46,0,0,1,.24-.56c.47-1.07,1-.93,1-.93a.73.73,0,0,0-.57.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C80.86,95.68,79.66,93.5,79.66,93.5Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M82.24,89.84s-2.46-.4-3.45,1A1,1,0,0,0,79,92.23a1,1,0,0,0,1,.09.72.72,0,0,0,.4-.74s.32.5-.52,1.3a4.8,4.8,0,0,1-.45.41l.47.33c.08-.22.16-.4.23-.56.48-1.06,1-.93,1-.93a.73.73,0,0,0-.56.63,1,1,0,0,0,.42.9,1,1,0,0,0,1.38-.24C83.44,92,82.24,89.84,82.24,89.84Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M84.82,86.18s-2.46-.39-3.45,1a1,1,0,0,0,1.23,1.48.73.73,0,0,0,.4-.75s.33.5-.51,1.31l-.45.41.46.33c.09-.23.16-.41.24-.57.47-1.06,1.05-.92,1.05-.92a.71.71,0,0,0-.56.63,1,1,0,0,0,.42.9A1,1,0,0,0,85,89.77C86,88.37,84.82,86.18,84.82,86.18Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M87.4,82.53s-2.46-.4-3.45,1a1,1,0,0,0,.24,1.39,1,1,0,0,0,1,.09.71.71,0,0,0,.4-.74s.33.49-.52,1.3c-.12.12-.27.26-.45.41l.47.33a4.46,4.46,0,0,1,.24-.56c.47-1.07,1.05-.93,1.05-.93a.73.73,0,0,0-.57.63,1,1,0,0,0,1.81.66C88.59,84.71,87.4,82.53,87.4,82.53Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M72.72,33S69,29,69,24.25c0,0,11.25,1.25,13.25,6.88C82.27,31.13,75.79,31.81,72.72,33Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M91.77,30.5s7-9.25,20.63-5.37c0,0,3.24,2.16-1.38,6.27A94.85,94.85,0,0,0,91.77,30.5Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.9,60.67s1.16,1.83.66,1.83A3.09,3.09,0,0,0,76.4,65S74.73,62.67,77.9,60.67Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.58,35.2c-.38,1.82-3.31,2,1,8.47,3.28,4.9.32,7.4-.83,11.33-2.83,9.75-1.16,15,8,17.67,0,0-14.75.83-10.41-13s-.09-14.08-1.09-17.58c-.64-2.23.34-5.08,1.67-6.84Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.9,35.63S94,39,98.52,45.75c5.24,7.87-3.75,12.5,1.38,20.13s13,5.86,15.43,5.74c0,0-11.31,1.38-14.43-6.12s3-13.87-1.13-20.62S95.9,36.75,95.9,35.63Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.68,118.28l9.2-11.49-3.52-2.18a15.49,15.49,0,0,1-3.78-4.41c-.34-.68-2.31.07-.6,3L40.37,106l-6.45-5.31s-3.54-3.21-3.7-1.72c-.1.93,1.29,2.85,1.88,3.25S37,107.69,37,107.69l-5.25-3.93s-3.87-3.18-4.2-2.66c-1.26,2,1.3,3.77,2,4.21s5.78,5,5.78,5l-6.88-3.86s-2.63-1.9-2.82-1.17c-.45,1.75,1.39,3,1.78,3.21.69.4,5.81,3.8,5.81,3.8l-1.81-.24s-5.3-1.92-5.33-1.46c-.19,2.3,9.32,6.27,9.32,6.27A22.78,22.78,0,0,0,37.68,118.28Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.06,109.29l-13.43-6,2.13-3.55a15.34,15.34,0,0,0,1.35-5.65c0-.76,2.09-1,1.9,2.39l.06,3.16L77.39,92s1.68-4.47,2.5-3.22c.51.79.15,3.13-.19,3.75s-1.86,7.08-1.86,7.08l2.87-5.9s2-4.6,2.53-4.28c2,1.19.56,3.94.14,4.65s-2.86,7.11-2.86,7.11l4.36-6.58s1.47-2.89,2-2.33c1.21,1.35.13,3.29-.11,3.66-.43.67-3.44,6-3.44,6l1.5-1s3.84-4.13,4.08-3.73c1.22,2-5.43,9.83-5.43,9.83A21.82,21.82,0,0,1,82.06,109.29Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-48",
    points: "82.83 109.09 53.42 93.24 32.84 122.33 76.68 117.67 82.66 109.9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M49.51,92.9s-2.88,1.44-2.86,3.65a1.27,1.27,0,0,0,1.29,1.28,1.29,1.29,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77a6,6,0,0,1-.17.76h.74c-.08-.29-.13-.55-.17-.77-.3-1.48.41-1.76.41-1.76A.92.92,0,0,0,50,97.17a1.28,1.28,0,0,0,2.39-.66C52.42,94.29,49.51,92.9,49.51,92.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M56.11,92.9s-2.89,1.44-2.87,3.65a1.29,1.29,0,0,0,2.41.63,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.22-.09.47-.17.76h.74a6.12,6.12,0,0,1-.17-.77c-.31-1.48.41-1.76.41-1.76a.93.93,0,0,0-.13,1.08,1.32,1.32,0,0,0,1.12.64A1.29,1.29,0,0,0,59,96.51C59,94.29,56.11,92.9,56.11,92.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M36.32,92.9s-2.89,1.44-2.87,3.65a1.29,1.29,0,0,0,2.41.63,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.22-.09.47-.17.76h.74a6.12,6.12,0,0,1-.17-.77c-.31-1.48.41-1.76.41-1.76a.93.93,0,0,0-.13,1.08,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C39.22,94.29,36.32,92.9,36.32,92.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M42.92,92.9S40,94.34,40.05,96.55a1.27,1.27,0,0,0,1.29,1.28,1.3,1.3,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a5.8,5.8,0,0,1-.16.76h.74c-.08-.29-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C45.82,94.29,42.92,92.9,42.92,92.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M75.8,92.9s-2.89,1.44-2.87,3.65a1.29,1.29,0,0,0,2.41.63,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.22-.09.47-.17.76h.74a6.12,6.12,0,0,1-.17-.77c-.31-1.48.41-1.76.41-1.76a.93.93,0,0,0-.13,1.08,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C78.7,94.29,75.8,92.9,75.8,92.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M82.4,92.9s-2.89,1.44-2.87,3.65a1.27,1.27,0,0,0,1.29,1.28,1.29,1.29,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.22-.09.47-.16.76h.74c-.08-.29-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C85.3,94.29,82.4,92.9,82.4,92.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M62.61,92.9s-2.89,1.44-2.87,3.65A1.27,1.27,0,0,0,61,97.83a1.29,1.29,0,0,0,1.11-.65A1,1,0,0,0,62,96.09s.71.28.43,1.77c0,.22-.09.47-.16.76H63c-.08-.29-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C65.51,94.29,62.61,92.9,62.61,92.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M69.2,92.9s-2.88,1.44-2.86,3.65a1.27,1.27,0,0,0,1.29,1.28,1.29,1.29,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77c0,.22-.09.47-.16.76h.74a6.33,6.33,0,0,1-.18-.77c-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C72.11,94.29,69.2,92.9,69.2,92.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M66.16,94.35S69,92.92,69,90.7a1.28,1.28,0,0,0-1.29-1.28,1.32,1.32,0,0,0-1.12.66,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.65C63.25,93,66.16,94.35,66.16,94.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M59.56,94.35s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.73c.08.29.13.54.17.76.3,1.48-.41,1.77-.41,1.77A.93.93,0,0,0,59,90.09a1.28,1.28,0,0,0-2.39.65C56.65,93,59.56,94.35,59.56,94.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M79.35,94.35s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62A.92.92,0,0,0,80,91.16s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.73c.08.29.13.54.17.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.65C76.44,93,79.35,94.35,79.35,94.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M72.75,94.35s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.17-.77h-.74a6,6,0,0,1,.17.76c.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.29,1.29,0,0,0-2.4.65C69.84,93,72.75,94.35,72.75,94.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M39.87,94.35s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.73c.08.29.13.54.17.76.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.65C37,93,39.87,94.35,39.87,94.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M33.27,94.35s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.54.17.76.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.29,1.29,0,0,0-2.4.65C30.37,93,33.27,94.35,33.27,94.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M53.06,94.35S56,92.92,55.93,90.7a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.17-.77h-.74a6,6,0,0,1,.17.76c.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.29,1.29,0,0,0-2.4.65C50.16,93,53.06,94.35,53.06,94.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M46.46,94.35s2.89-1.43,2.87-3.65A1.28,1.28,0,0,0,48,89.42a1.32,1.32,0,0,0-1.12.66,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76a6.27,6.27,0,0,1,.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.65C43.56,93,46.46,94.35,46.46,94.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M49.51,102.34s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77a6.41,6.41,0,0,1-.17.76h.74c-.08-.3-.13-.55-.17-.77-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C52.42,103.73,49.51,102.34,49.51,102.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M56.11,102.34s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.76.41-1.76a.93.93,0,0,0-.13,1.08,1.32,1.32,0,0,0,1.12.64A1.29,1.29,0,0,0,59,106C59,103.73,56.11,102.34,56.11,102.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M36.32,102.34s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.76.41-1.76a.93.93,0,0,0-.13,1.08,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C39.22,103.73,36.32,102.34,36.32,102.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M42.92,102.34S40,103.77,40.05,106a1.28,1.28,0,0,0,1.29,1.28,1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C45.82,103.73,42.92,102.34,42.92,102.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M75.8,102.34s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.76.41-1.76a.93.93,0,0,0-.13,1.08,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C78.7,103.73,75.8,102.34,75.8,102.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M82.4,102.34s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C85.3,103.73,82.4,102.34,82.4,102.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M62.61,102.34s-2.89,1.43-2.87,3.65A1.28,1.28,0,0,0,61,107.27a1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76H63c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C65.51,103.73,62.61,102.34,62.61,102.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M69.2,102.34s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.16.76h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C72.11,103.73,69.2,102.34,69.2,102.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M66.16,103.79S69,102.36,69,100.14a1.28,1.28,0,0,0-1.29-1.28,1.32,1.32,0,0,0-1.12.66,1,1,0,0,0,.14,1.08s-.71-.28-.43-1.76c0-.22.09-.48.16-.77h-.74c.08.3.14.55.18.77.3,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.12-1.09,1.29,1.29,0,0,0-2.4.66C63.25,102.4,66.16,103.79,66.16,103.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M59.56,103.79s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.73c.08.3.13.55.17.77.3,1.48-.41,1.77-.41,1.77A1,1,0,0,0,59,99.52a1.28,1.28,0,0,0-2.39.66C56.65,102.4,59.56,103.79,59.56,103.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M79.35,103.79s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62A.92.92,0,0,0,80,100.6s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.73c.08.3.13.55.17.77.3,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C76.44,102.4,79.35,103.79,79.35,103.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M72.75,103.79s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.13-1.09,1.29,1.29,0,0,0-2.4.66C69.84,102.4,72.75,103.79,72.75,103.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M39.87,103.79s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.92.92,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.73c.08.3.13.55.17.77.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C37,102.4,39.87,103.79,39.87,103.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M33.27,103.79s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74c.08.3.13.55.17.77.31,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.13-1.09,1.29,1.29,0,0,0-1.13-.63,1.28,1.28,0,0,0-1.27,1.29C30.37,102.4,33.27,103.79,33.27,103.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M53.06,103.79s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.13-1.09,1.29,1.29,0,0,0-2.4.66C50.16,102.4,53.06,103.79,53.06,103.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M46.46,103.79s2.89-1.43,2.87-3.65A1.28,1.28,0,0,0,48,98.86a1.32,1.32,0,0,0-1.12.66,1,1,0,0,0,.14,1.08s-.71-.28-.43-1.76a5.91,5.91,0,0,1,.16-.77h-.74c.08.3.14.55.18.77.3,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.12-1.09,1.29,1.29,0,0,0-2.4.66C43.56,102.4,46.46,103.79,46.46,103.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M49.51,111.78s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.76a6.12,6.12,0,0,1-.17.77h.74c-.08-.3-.13-.55-.17-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.09,1.28,1.28,0,0,0,2.39-.66C52.42,113.17,49.51,111.78,49.51,111.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M56.11,111.78s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.63,1,1,0,0,0-.14-1.09s.72.28.44,1.76c0,.22-.09.48-.17.77h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.77.41-1.77a1,1,0,0,0-.13,1.09,1.29,1.29,0,0,0,2.4-.66C59,113.17,56.11,111.78,56.11,111.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M36.32,111.78s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.63,1,1,0,0,0-.14-1.09s.72.28.44,1.76c0,.22-.09.48-.17.77h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.77.41-1.77a1,1,0,0,0-.13,1.09,1.29,1.29,0,0,0,2.4-.66C39.22,113.17,36.32,111.78,36.32,111.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M42.92,111.78s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,1.29,1.28,1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.76a5.91,5.91,0,0,1-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.09,1.29,1.29,0,0,0,2.4-.66C45.82,113.17,42.92,111.78,42.92,111.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M75.8,111.78s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.63A1,1,0,0,0,75.2,115s.72.28.44,1.76c0,.22-.09.48-.17.77h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.77.41-1.77a1,1,0,0,0-.13,1.09,1.29,1.29,0,0,0,2.4-.66C78.7,113.17,75.8,111.78,75.8,111.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M82.4,111.78s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65A1,1,0,0,0,81.8,115s.71.28.43,1.76c0,.22-.09.48-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.09,1.29,1.29,0,0,0,2.4-.66C85.3,113.17,82.4,111.78,82.4,111.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M62.61,111.78s-2.89,1.43-2.87,3.65A1.28,1.28,0,0,0,61,116.71a1.31,1.31,0,0,0,1.11-.65A1,1,0,0,0,62,115s.71.28.43,1.76c0,.22-.09.48-.16.77H63c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.09,1.29,1.29,0,0,0,2.4-.66C65.51,113.17,62.61,111.78,62.61,111.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M69.2,111.78s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65A.94.94,0,0,0,68.6,115s.72.28.44,1.76c0,.22-.09.48-.16.77h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.09,1.28,1.28,0,0,0,2.39-.66C72.11,113.17,69.2,111.78,69.2,111.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M66.16,113.23S69,111.8,69,109.58a1.28,1.28,0,0,0-1.29-1.28,1.34,1.34,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.76c0-.22.09-.48.16-.77h-.74c.08.3.14.55.18.77.3,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.12-1.09,1.29,1.29,0,0,0-2.4.66C63.25,111.84,66.16,113.23,66.16,113.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M59.56,113.23s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-1.29-1.28A1.31,1.31,0,0,0,60,109a.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.73c.08.3.13.55.17.77.3,1.48-.41,1.77-.41,1.77A1,1,0,0,0,59,109a1.28,1.28,0,0,0-2.39.66C56.65,111.84,59.56,113.23,59.56,113.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M79.35,113.23s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-1.29-1.28,1.31,1.31,0,0,0-1.11.65A.94.94,0,0,0,80,110s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.73c.08.3.13.55.17.77.3,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C76.44,111.84,79.35,113.23,79.35,113.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M72.75,113.23s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.13-1.09,1.29,1.29,0,0,0-2.4.66C69.84,111.84,72.75,113.23,72.75,113.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M39.87,113.23s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.73c.08.3.13.55.17.77.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C37,111.84,39.87,113.23,39.87,113.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M33.27,113.23s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74c.08.3.13.55.17.77.31,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.13-1.09,1.29,1.29,0,0,0-1.13-.63,1.28,1.28,0,0,0-1.27,1.29C30.37,111.84,33.27,113.23,33.27,113.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M53.06,113.23s2.89-1.43,2.87-3.65a1.3,1.3,0,0,0-1.3-1.28,1.32,1.32,0,0,0-1.11.65,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.13-1.09,1.29,1.29,0,0,0-2.4.66C50.16,111.84,53.06,113.23,53.06,113.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M46.46,113.23s2.89-1.43,2.87-3.65A1.28,1.28,0,0,0,48,108.3a1.34,1.34,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.76a5.91,5.91,0,0,1,.16-.77h-.74c.08.3.14.55.18.77.3,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.12-1.09,1.29,1.29,0,0,0-2.4.66C43.56,111.84,46.46,113.23,46.46,113.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M49.51,121.22s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.92.92,0,0,0-.14-1.08s.72.28.44,1.76a6.12,6.12,0,0,1-.17.77h.74c-.08-.3-.13-.55-.17-.77-.3-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.65C52.42,122.61,49.51,121.22,49.51,121.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M56.11,121.22s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.17.77h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.77.41-1.77a.93.93,0,0,0-.13,1.08,1.29,1.29,0,0,0,2.4-.65C59,122.61,56.11,121.22,56.11,121.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M36.32,121.22s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.17.77h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.77.41-1.77a.93.93,0,0,0-.13,1.08,1.29,1.29,0,0,0,2.4-.65C39.22,122.61,36.32,121.22,36.32,121.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M42.92,121.22s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.12-.66,1,1,0,0,0-.14-1.08s.71.28.43,1.76a5.91,5.91,0,0,1-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.65C45.82,122.61,42.92,121.22,42.92,121.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M75.8,121.22s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.17.77h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.77.41-1.77a.93.93,0,0,0-.13,1.08,1.29,1.29,0,0,0,2.4-.65C78.7,122.61,75.8,121.22,75.8,121.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M82.4,121.22s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.28.43,1.76c0,.22-.09.48-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.65C85.3,122.61,82.4,121.22,82.4,121.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M62.61,121.22s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.28.43,1.76c0,.22-.09.48-.16.77H63c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.65C65.51,122.61,62.61,121.22,62.61,121.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M69.2,121.22s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.92.92,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.16.77h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.65C72.11,122.61,69.2,121.22,69.2,121.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M66.16,122.67S69,121.24,69,119a1.28,1.28,0,0,0-1.29-1.28,1.32,1.32,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77c0-.22.09-.47.16-.76h-.74c.08.3.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C63.25,121.28,66.16,122.67,66.16,122.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M59.56,122.67s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.63.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.16-.76h-.73c.08.3.13.55.17.77.3,1.48-.41,1.76-.41,1.76A.93.93,0,0,0,59,118.4a1.28,1.28,0,0,0-2.39.66C56.65,121.28,59.56,122.67,59.56,122.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M79.35,122.67s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.63.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.16-.76h-.73c.08.3.13.55.17.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C76.44,121.28,79.35,122.67,79.35,122.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M72.75,122.67s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76h-.74a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.13-1.08,1.32,1.32,0,0,0-1.12-.64,1.29,1.29,0,0,0-1.28,1.3C69.84,121.28,72.75,122.67,72.75,122.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M39.87,122.67s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.16-.76h-.73c.08.3.13.55.17.77.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C37,121.28,39.87,122.67,39.87,122.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M33.27,122.67s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76h-.74c.08.3.13.55.17.77.31,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.13-1.08,1.32,1.32,0,0,0-1.13-.64,1.29,1.29,0,0,0-1.27,1.3C30.37,121.28,33.27,122.67,33.27,122.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M53.06,122.67S56,121.24,55.93,119a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76h-.74a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.13-1.08,1.32,1.32,0,0,0-1.12-.64,1.29,1.29,0,0,0-1.28,1.3C50.16,121.28,53.06,122.67,53.06,122.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M46.46,122.67s2.89-1.43,2.87-3.65A1.28,1.28,0,0,0,48,117.74a1.32,1.32,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a5.8,5.8,0,0,1,.16-.76h-.74c.08.3.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.32,1.32,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C43.56,121.28,46.46,122.67,46.46,122.67Z"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "53.72 93.02 57.43 95.2 38.34 121.62 32.91 122.45 53.72 93.02"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M97.68,110.34s-3.26-.77-4.72,1a1.34,1.34,0,0,0,1.5,2.1,1,1,0,0,0,.61-1s.39.7-.82,1.7c-.17.15-.39.32-.64.5l.59.49c.13-.28.26-.53.37-.73.75-1.38,1.51-1.13,1.51-1.13a1,1,0,0,0-.82.78,1.3,1.3,0,0,0,.47,1.25,1.33,1.33,0,0,0,1.88-.18C99.07,113.39,97.68,110.34,97.68,110.34Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M101.5,105.69s-3.26-.77-4.72,1a1.34,1.34,0,0,0,1.5,2.1,1,1,0,0,0,.61-1s.39.7-.82,1.7c-.17.15-.39.32-.64.5l.59.49c.13-.29.26-.53.37-.73.75-1.38,1.51-1.13,1.51-1.13a1,1,0,0,0-.82.78,1.3,1.3,0,0,0,.47,1.25,1.33,1.33,0,0,0,1.88-.18C102.89,108.74,101.5,105.69,101.5,105.69Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M105.32,101s-3.26-.77-4.72,1a1.34,1.34,0,0,0,1.5,2.1,1,1,0,0,0,.61-1s.39.7-.82,1.7c-.17.15-.39.32-.64.51l.59.48c.13-.28.26-.52.37-.73.75-1.38,1.51-1.13,1.51-1.13a1,1,0,0,0-.82.78,1.32,1.32,0,0,0,.47,1.26,1.34,1.34,0,0,0,1.88-.19C106.71,104.09,105.32,101,105.32,101Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M109.14,96.4s-3.26-.78-4.72,1a1.34,1.34,0,0,0,1.5,2.1.94.94,0,0,0,.61-1s.39.69-.82,1.69c-.17.16-.39.32-.64.51l.59.48c.13-.28.26-.52.37-.72.75-1.39,1.51-1.14,1.51-1.14a1,1,0,0,0-.82.78,1.32,1.32,0,0,0,.47,1.26,1.34,1.34,0,0,0,1.88-.19C110.53,99.44,109.14,96.4,109.14,96.4Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M113,91.75s-3.26-.78-4.72,1a1.34,1.34,0,0,0,1.51,2.1,1,1,0,0,0,.61-.95s.38.7-.83,1.69c-.17.15-.39.32-.64.51l.59.49c.13-.29.26-.53.37-.73.75-1.39,1.51-1.14,1.51-1.14a1,1,0,0,0-.82.78,1.33,1.33,0,0,0,2.35,1.07C114.35,94.79,113,91.75,113,91.75Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M116.78,87.1s-3.26-.78-4.72,1a1.33,1.33,0,0,0,1.5,2.09.94.94,0,0,0,.61-1s.39.7-.82,1.69c-.17.16-.39.32-.64.51l.59.49c.13-.29.26-.53.37-.73.75-1.39,1.51-1.14,1.51-1.14a1,1,0,0,0-.82.79,1.31,1.31,0,0,0,.47,1.25,1.33,1.33,0,0,0,1.88-.18C118.17,90.14,116.78,87.1,116.78,87.1Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M120.6,82.45s-3.26-.78-4.72,1a1.33,1.33,0,0,0,.18,1.88,1.36,1.36,0,0,0,1.32.22,1,1,0,0,0,.62-1s.38.7-.83,1.7c-.17.15-.39.31-.64.5l.59.49c.13-.29.26-.53.37-.73.75-1.38,1.51-1.14,1.51-1.14a1,1,0,0,0-.82.79,1.31,1.31,0,0,0,.47,1.25,1.33,1.33,0,0,0,1.88-.18C122,85.49,120.6,82.45,120.6,82.45Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M124.42,77.8s-3.26-.77-4.72,1a1.33,1.33,0,0,0,.18,1.88,1.37,1.37,0,0,0,1.33.22,1,1,0,0,0,.61-1s.38.7-.83,1.7c-.17.15-.39.32-.64.5l.59.49c.13-.29.26-.53.37-.73.75-1.38,1.51-1.14,1.51-1.14a1,1,0,0,0-.82.79,1.31,1.31,0,0,0,.47,1.25,1.33,1.33,0,0,0,1.88-.18C125.81,80.85,124.42,77.8,124.42,77.8Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.94,109.49s-2.7-.64-3.92.83a1.11,1.11,0,0,0,1.25,1.75.81.81,0,0,0,.51-.79s.32.57-.69,1.4a5.46,5.46,0,0,1-.53.42l.49.41c.11-.24.22-.44.31-.61.62-1.15,1.25-.94,1.25-.94a.8.8,0,0,0-.68.65,1.09,1.09,0,0,0,.39,1,1.11,1.11,0,0,0,1.56-.15C108.09,112,106.94,109.49,106.94,109.49Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.11,105.64s-2.7-.64-3.91.83a1.1,1.1,0,0,0,.15,1.56,1.09,1.09,0,0,0,1.09.18.79.79,0,0,0,.51-.79s.32.58-.68,1.41l-.54.42.49.4c.11-.24.22-.44.31-.6.62-1.15,1.25-.94,1.25-.94a.79.79,0,0,0-.68.65,1.11,1.11,0,0,0,2,.88C111.26,108.17,110.11,105.64,110.11,105.64Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.28,101.79s-2.7-.65-3.91.83a1.11,1.11,0,0,0,.15,1.56,1.09,1.09,0,0,0,1.09.18.8.8,0,0,0,.51-.79s.32.58-.68,1.4q-.22.19-.54.42l.49.41c.11-.24.22-.44.31-.61.62-1.14,1.25-.94,1.25-.94a.82.82,0,0,0-.68.65,1.11,1.11,0,0,0,2,.89C114.44,104.31,113.28,101.79,113.28,101.79Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.46,97.94s-2.71-.65-3.92.83a1.11,1.11,0,0,0,.15,1.56,1.13,1.13,0,0,0,1.1.18.81.81,0,0,0,.5-.79s.32.57-.68,1.4a5.71,5.71,0,0,1-.54.42l.5.41a6.81,6.81,0,0,1,.31-.61c.61-1.15,1.24-.94,1.24-.94a.81.81,0,0,0-.68.65,1.11,1.11,0,0,0,2,.89C117.61,100.46,116.46,97.94,116.46,97.94Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.63,94.08s-2.7-.64-3.92.83a1.11,1.11,0,0,0,.15,1.56,1.14,1.14,0,0,0,1.1.19.81.81,0,0,0,.5-.8s.33.58-.68,1.41c-.15.13-.32.27-.53.42l.49.4q.17-.34.3-.6c.62-1.15,1.25-.94,1.25-.94a.81.81,0,0,0-.68.65,1.12,1.12,0,0,0,.39,1,1.1,1.1,0,0,0,1.56-.16C120.78,96.61,119.63,94.08,119.63,94.08Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.8,90.23s-2.7-.65-3.92.83a1.11,1.11,0,0,0,1.25,1.74.79.79,0,0,0,.5-.79s.33.58-.68,1.41l-.53.42.49.4a5.43,5.43,0,0,1,.31-.6c.62-1.15,1.25-1,1.25-1a.81.81,0,0,0-.68.65,1.1,1.1,0,0,0,1.94.89C124,92.76,122.8,90.23,122.8,90.23Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126,86.38s-2.7-.65-3.92.83A1.11,1.11,0,0,0,123.3,89a.82.82,0,0,0,.51-.79s.32.57-.69,1.4a5.46,5.46,0,0,1-.53.42l.49.41a6.81,6.81,0,0,1,.31-.61c.62-1.14,1.25-.94,1.25-.94a.8.8,0,0,0-.68.65,1.11,1.11,0,0,0,2,.89C127.12,88.9,126,86.38,126,86.38Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.14,82.52s-2.7-.64-3.92.83a1.11,1.11,0,0,0,.16,1.56,1.09,1.09,0,0,0,1.09.19.81.81,0,0,0,.51-.8s.32.58-.69,1.41a5.46,5.46,0,0,1-.53.42l.49.4c.11-.23.22-.43.31-.6.62-1.15,1.25-.94,1.25-.94a.8.8,0,0,0-.68.65,1.09,1.09,0,0,0,.39,1,1.11,1.11,0,0,0,1.56-.15C130.29,85.05,129.14,82.52,129.14,82.52Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.31,78.67s-2.7-.64-3.91.83a1.11,1.11,0,0,0,1.24,1.74.79.79,0,0,0,.51-.79s.32.58-.68,1.41l-.54.42.49.4c.11-.24.22-.44.31-.6.62-1.15,1.25-.94,1.25-.94a.8.8,0,0,0-.68.64,1.11,1.11,0,0,0,1.95.89C133.46,81.2,132.31,78.67,132.31,78.67Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M87.78,22s-4.53,2.28-4.48,5.76a2,2,0,0,0,3.78,1,1.47,1.47,0,0,0-.22-1.7s1.12.43.69,2.76a10.94,10.94,0,0,1-.25,1.21h1.16c-.12-.46-.21-.86-.28-1.2-.48-2.33.64-2.78.64-2.78a1.45,1.45,0,0,0-.19,1.7,2,2,0,0,0,3.76-1C92.35,24.12,87.78,22,87.78,22Z"
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 19,
    transform: "translate(23.79 95.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAATCAYAAACKsM07AAAACXBIWXMAAAsSAAALEgHS3X78AAACcklEQVQ4T6WU/W7USBDEf9U99q4ED4LEvcoJIYjgEYM2EbpH48Jmsx5PN3+MbZKQID5KstY7M+6qru5pZSbP4fJwlW4OQItG8YIk6lz5ePFez354D3qK4NPhOksplOJIAgmT4e60NjPVCgmtNVq0n5L9QHC4/pzjODCOI5nJOI6Y9eAJfL25obVgv99ze3tLa41SCnfnuyeJHhBcf/4vvThdfcFkmPVv9vs9tVYikiS7+tYwM+pUqXNlmqYfSDaCy8NVrkFfvnyBu+OlYBKScHcigsyktSAiaG3GvXA8HpmmCZmoU+XDxbuNRJnZg3tht9sxDIXdbo8ESIzDAIC5E4tqEJmdBIm5Vk6nE3d3Z1CvzZqJAZiMUkoPZIZMmDnFfUs1I7Z96FlnZicBhmFkHId1a4MBRPZDkpCMjCAzHgSIyO1/t6n19SUjAPfCOI5AtxygrEy6V5rM3B5JyztAbjWAbkVEbuu9CQI334QV6BZFJO4Q0TDTA5JFQi9srMFjySqYWyOjn+sWdlwertJfvf4n3XtrIhjKgLQeFNJ3WyPa9tuJk/P5THHfsl2zWZ+yskpQvDu2qu51MMhkXnp+3ZPg5uZIRGOa6rLWCdaawL0aQFfWmijFaS0w67bIjPP5DIgv/3/BzfsFmytCS3OIuc08RoHvRQWWoIlZVy+J49cjp9MJSezGHW/f/Pvs7Fm7B+DjxXsV6G2a9MG2JlhrxcyZ58rxeAvw4IY+h8ejooilY6L7HBGYWe+WuTFNE0n+8nh+jJIkBP0CkaQZtc4b0VO+/g6UmXw6XKeZgUAIM2Oq03boT9XDo2lqsm1swN8FXvENTOvFOJJyeqYAAAAASUVORK5CYII="
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 82,
    transform: "translate(32.79 17.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAABSCAYAAAB306WpAAAACXBIWXMAAAsSAAALEgHS3X78AAABzklEQVRIS6VVy27bMBCcXdK20uQWBPn/e4w4/xUUDlogtkVycliKEkWqgFGeJI3msUNCAkmQxNv7idM1SSjyEgiWS7Gx/gOoHZYMudc8MfWB++Y4nj4oPfO1TAGAJu3SoyPlnCKm2GdsxN0wdyroxmWH8+92vXf9OSzRRoki1lkNiLGWs8xSUvuXSva7XcuA0SpKASzyCiAAFWk9AEBVWwZAHA77FhCxdm+3cQXkmKqdVM71PGSWqwCBPdQ1MAx7DIc9ROci5q3tSU2b3kgBLD61FLNUb46uFEF416k9x+pLSVeKG6mQh/v8fa6B6T2VVSWZ1Ho8Pf0ycJ2KtCPbTQUIRLUc7NJVvxLSTmg7+aaH3bRbm036HnLfHHbTeCxTvb4814wYE3TNeHx8gIjAe4fz158ZCCGAJJxTeO+WQERiglPFzvsZGEMAE6HO1QwmTieoHAgFgGE4GJiI89dfA46nD45jQEwRKQeoPGJMuFyuMyAQhNEAEYFz2ZxgLoT1R0ZF4J2zWWLE9/fFgEQCYtOHEBFCnBhaHqTE8nXQxFTeVhWkZI5+8iVQ9IEpboy4Xm8lMjDFJTGOATHG8tuT47v9uEQEJAvgJwbKN9rWD40g6wqKWIX1AAAAAElFTkSuQmCC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M111.34,30.41s-1.58.66-1.65,1.84a.68.68,0,0,0,.65.72.67.67,0,0,0,.61-.31.48.48,0,0,0,0-.58s.38.18.17,1a3.21,3.21,0,0,1-.11.41l.39,0c0-.16,0-.3-.06-.41-.11-.8.28-.93.28-.93a.49.49,0,0,0-.11.57.71.71,0,0,0,.58.38.69.69,0,0,0,.72-.64C112.84,31.25,111.34,30.41,111.34,30.41Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M108.27,30.23s-1.58.67-1.65,1.84a.69.69,0,0,0,1.26.42.5.5,0,0,0,0-.58s.37.17.17.95c0,.11-.06.25-.11.4l.39,0c0-.16-.05-.29-.07-.41-.11-.8.28-.92.28-.92a.5.5,0,0,0-.1.57.68.68,0,0,0,1.29-.27C109.76,31.07,108.27,30.23,108.27,30.23Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M105.19,30.06s-1.58.66-1.65,1.84a.68.68,0,0,0,.65.72.67.67,0,0,0,.61-.31.5.5,0,0,0,0-.58s.37.17.17.95c0,.12-.07.25-.12.41l.39,0a4.22,4.22,0,0,1-.06-.42c-.11-.79.28-.92.28-.92a.48.48,0,0,0-.1.57.68.68,0,0,0,1.29-.27C106.69,30.9,105.19,30.06,105.19,30.06Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M102.12,29.88s-1.58.67-1.65,1.84a.7.7,0,0,0,.64.73.72.72,0,0,0,.62-.31.5.5,0,0,0,0-.58s.37.17.17.95a3.11,3.11,0,0,1-.11.4l.39,0c0-.15,0-.29-.07-.41-.11-.8.28-.92.28-.92a.5.5,0,0,0-.1.57.68.68,0,0,0,1.29-.27C103.61,30.72,102.12,29.88,102.12,29.88Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M99,29.71s-1.58.66-1.64,1.84a.68.68,0,0,0,.64.72.69.69,0,0,0,.61-.31.5.5,0,0,0,0-.58s.37.17.17.95c0,.12-.07.25-.12.4l.4,0a2.61,2.61,0,0,1-.07-.42c-.11-.79.28-.92.28-.92a.5.5,0,0,0-.1.57.69.69,0,0,0,.57.38.68.68,0,0,0,.72-.65C100.54,30.55,99,29.71,99,29.71Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M96,29.53s-1.58.66-1.65,1.84a.7.7,0,0,0,.65.73.71.71,0,0,0,.61-.31.5.5,0,0,0,0-.58s.37.17.17.95a3.63,3.63,0,0,1-.11.4l.39,0a4.07,4.07,0,0,1-.06-.41c-.11-.8.27-.93.27-.93a.51.51,0,0,0-.1.58.68.68,0,0,0,.57.37.68.68,0,0,0,.73-.64C97.46,30.37,96,29.53,96,29.53Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M92.67,29.55s-1.46.89-1.35,2.07a.68.68,0,0,0,.74.62.7.7,0,0,0,.56-.4.52.52,0,0,0-.12-.57s.39.12.31.92a4.07,4.07,0,0,1-.06.41l.39,0c0-.15-.09-.29-.12-.4-.23-.77.14-1,.14-1a.5.5,0,0,0,0,.58.68.68,0,0,0,1.24-.45C94.28,30.16,92.67,29.55,92.67,29.55Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M89.61,29.83s-1.47.89-1.36,2.07a.69.69,0,0,0,.74.62.7.7,0,0,0,.56-.4.49.49,0,0,0-.12-.57s.39.12.31.92c0,.12,0,.25,0,.41l.39,0c-.06-.16-.1-.29-.13-.4-.22-.77.14-1,.14-1a.5.5,0,0,0,0,.58.69.69,0,0,0,1.25-.45C91.21,30.44,89.61,29.83,89.61,29.83Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M86.54,30.11s-1.46.89-1.36,2.06a.68.68,0,0,0,.74.62.66.66,0,0,0,.56-.39.49.49,0,0,0-.12-.57s.39.12.31.92a4.09,4.09,0,0,1,0,.41l.39,0c-.05-.15-.09-.28-.13-.39-.22-.77.14-1,.14-1a.5.5,0,0,0,0,.58.68.68,0,0,0,1.24-.45C88.14,30.72,86.54,30.11,86.54,30.11Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M83.47,30.39s-1.46.89-1.35,2.06a.67.67,0,0,0,.74.62.69.69,0,0,0,.56-.39.52.52,0,0,0-.12-.57s.39.12.31.92c0,.11,0,.25-.06.41l.39,0q-.07-.23-.12-.39c-.23-.78.14-1,.14-1a.5.5,0,0,0,0,.58.7.7,0,0,0,.62.29.69.69,0,0,0,.62-.75C85.08,31,83.47,30.39,83.47,30.39Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M80.41,30.67s-1.47.89-1.36,2.06a.68.68,0,0,0,.74.62.69.69,0,0,0,.56-.39.49.49,0,0,0-.12-.57s.39.11.31.91c0,.12,0,.26-.05.42l.39,0a3.05,3.05,0,0,1-.13-.4c-.22-.77.14-1,.14-1a.5.5,0,0,0,0,.58.71.71,0,0,0,.63.29.7.7,0,0,0,.62-.75C82,31.28,80.41,30.67,80.41,30.67Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M77.23,31.2s-1.38,1-1.16,2.18a.69.69,0,0,0,.8.55.7.7,0,0,0,.52-.45.48.48,0,0,0-.18-.55s.41.08.4.88a3.25,3.25,0,0,1,0,.42l.39-.08a3.52,3.52,0,0,1-.16-.38c-.3-.75.05-1,.05-1a.49.49,0,0,0,0,.57.67.67,0,0,0,.65.23.68.68,0,0,0,.55-.79C78.88,31.66,77.23,31.2,77.23,31.2Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M74.2,31.76s-1.37,1-1.16,2.18a.68.68,0,0,0,1.32.1.49.49,0,0,0-.17-.55s.4.08.39.88c0,.12,0,.26,0,.42l.38-.07c-.07-.15-.12-.28-.16-.39-.3-.74,0-1,0-1a.49.49,0,0,0,0,.58.68.68,0,0,0,1.19-.57C75.85,32.22,74.2,31.76,74.2,31.76Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.24,200.53S108,216.34,80.43,215.78a47.81,47.81,0,0,1-18.75-4.5s-18.74.79-8.8-9.5Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.61,198.75s23.5,1.19,39.24-1l.83,3.16a270.2,270.2,0,0,1-40.43,1.3Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M66.56,161l-28.37-5.35s-5.62-.54-5.62-7.24V122.74l99.6-11.52s-25.12,37.5-32.95,44.2c-.88.75-4.92,1.64-9.88,2.48C79.69,159.55,66.56,161,66.56,161Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.76,199.06l19.74-1.57L92,195.3l2.49-13.76-2.71-.71.38-3.13-2.3-1.47.19-1.78s-2.56-1.06-1.07-2.57,2.8-4.39-4.29-4.79c-4.33-.25-6.53-2.26-2.91-8.44,0,.57-3-4-7.66-4.3-7.18-.41-17.14,3.21-17.14,3.21S72.42,193.32,72.76,199.06Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.49,195a2.3,2.3,0,0,0-1.23-2.92,12.87,12.87,0,0,0-2.76.84c-1.62.66-5.16.22-5.65-.35s1,3.29,6.63,1.61C92,193.13,91.49,195,91.49,195Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.53,190.57a6,6,0,0,0-3.26.08c-1.61.55-3.85.43-4.92-.57a9.16,9.16,0,0,0,4.29-.28s-.55-2,.67-2.2,1.29,2,1.29,2A3.17,3.17,0,0,1,90.53,190.57Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.31,199.16s3-3.94,1.75-5.75c-3.88-5.88-2.69-13.83-.88-22.74,0,0,6.22-14.21-26.3-8.63,0,0,4.64,3.61,2.93,14.37-.91,5.72-3.89,23,1,22.25Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.75,158.77l38.57-43-56.75,7v29.6a11.62,11.62,0,0,0,5.62,3.35C41.44,156.36,50.75,158.77,50.75,158.77Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "51.56 158.88 90.89 115.71 82.45 116.57 46.1 157.76 51.56 158.88"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37,155.55s-4.44-.8-4.44-3.21L59.4,119.59l7.76-1Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "51.76 158.93 50.42 154.05 58.46 151.2 59.65 143.73 67.24 141.56 67.84 134.37 75.58 132.33 77.07 124.19 83.47 123.37 51.76 158.93"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.49,200.69l-.77-3.2s-21.93,2-39.48,1c-.94-.05.23.26.23.26s20.8,1.2,38.53-.21C92,198.55,92.74,198.72,93.49,200.69Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "47.21 157.82 45.89 157.5 82.47 116.57 84.31 115.99 47.21 157.82"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.29,161.71l6.37-3.08s-1.22-7-15.48-7.36c-11.29-.29-19.75,7.48-19.75,7.48L57.72,160s5.26-3.49,13.73-2.86C78.72,157.66,80.29,161.71,80.29,161.71Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M86.32,132.21s2.46.4,3.45-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.08.69.69,0,0,0-.4.74s-.33-.5.51-1.31l.45-.41-.46-.32c-.09.22-.16.4-.24.56-.47,1.06-1.05.92-1.05.92a.71.71,0,0,0,.56-.62,1,1,0,0,0-.41-.91,1,1,0,0,0-1.39.24C85.12,130,86.32,132.21,86.32,132.21Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M83.74,135.87s2.46.4,3.45-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.33-.49.52-1.3c.12-.12.27-.26.45-.41l-.47-.33a4.46,4.46,0,0,1-.24.56c-.47,1.07-1,.93-1,.93a.72.72,0,0,0,.56-.63,1,1,0,0,0-.41-.9,1,1,0,0,0-1.39.24C82.54,133.69,83.74,135.87,83.74,135.87Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M81.17,139.53s2.46.39,3.44-1a1,1,0,0,0-1.23-1.48.72.72,0,0,0-.4.74s-.33-.5.52-1.3a4.8,4.8,0,0,1,.45-.41l-.47-.33c-.08.22-.16.4-.23.56-.48,1.07-1.06.93-1.06.93a.73.73,0,0,0,.57-.63,1,1,0,0,0-.42-.9A1,1,0,0,0,81,136C80,137.35,81.17,139.53,81.17,139.53Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M78.59,143.19s2.46.39,3.45-1a1,1,0,0,0-.25-1.38,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.32-.5.52-1.3a4.8,4.8,0,0,1,.45-.41l-.47-.33c-.08.22-.16.4-.23.56-.48,1.06-1,.92-1,.92a.71.71,0,0,0,.56-.62,1,1,0,0,0-.42-.91,1,1,0,0,0-1.38.24C77.39,141,78.59,143.19,78.59,143.19Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M76,146.84s2.46.4,3.45-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.09.72.72,0,0,0-.4.75s-.33-.5.51-1.31c.13-.12.27-.26.45-.41l-.46-.33c-.09.22-.16.41-.24.56-.47,1.07-1,.93-1,.93a.72.72,0,0,0,.56-.63,1,1,0,0,0-1.8-.66C74.81,144.66,76,146.84,76,146.84Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M73.44,150.5s2.45.4,3.44-1a1,1,0,0,0-.24-1.38,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.33-.49.52-1.3c.12-.12.27-.26.45-.41l-.47-.33c-.08.22-.16.41-.23.56-.48,1.07-1.06.93-1.06.93a.73.73,0,0,0,.57-.63,1,1,0,0,0-1.81-.66C72.24,148.32,73.44,150.5,73.44,150.5Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M79.84,132.1s2.46.4,3.45-1a1,1,0,0,0-1.23-1.47.72.72,0,0,0-.4.74s-.33-.5.52-1.3c.12-.12.26-.26.44-.41l-.46-.33a5.22,5.22,0,0,1-.24.56c-.47,1.07-1,.93-1,.93a.72.72,0,0,0,.56-.63,1,1,0,0,0-.41-.9,1,1,0,0,0-1.39.24C78.64,129.92,79.84,132.1,79.84,132.1Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M77.27,135.76s2.46.39,3.44-1a1,1,0,0,0-.24-1.38,1,1,0,0,0-1-.09.71.71,0,0,0-.4.74s-.33-.5.52-1.3a4.8,4.8,0,0,1,.45-.41l-.47-.33a5.22,5.22,0,0,1-.24.56c-.47,1.06-1,.92-1,.92a.72.72,0,0,0,.57-.62,1,1,0,0,0-.42-.91,1,1,0,0,0-1.38.24C76.07,133.57,77.27,135.76,77.27,135.76Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M74.69,139.41s2.46.4,3.44-1A1,1,0,0,0,77.9,137a1,1,0,0,0-1-.09.73.73,0,0,0-.4.75s-.32-.5.52-1.31c.12-.12.27-.26.45-.41l-.47-.33c-.08.22-.16.41-.23.56-.48,1.07-1,.93-1,.93a.73.73,0,0,0,.56-.63,1,1,0,0,0-.42-.9,1,1,0,0,0-1.38.24C73.49,137.23,74.69,139.41,74.69,139.41Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M72.11,143.07s2.46.4,3.45-1a1,1,0,0,0-1.23-1.48.71.71,0,0,0-.4.74s-.33-.49.51-1.3c.13-.12.27-.26.45-.41l-.47-.33c-.08.22-.16.4-.23.56-.47,1.07-1,.93-1,.93a.72.72,0,0,0,.56-.63,1,1,0,0,0-.41-.9,1,1,0,0,0-1.39.24C70.91,140.89,72.11,143.07,72.11,143.07Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M69.54,146.73s2.45.39,3.44-1a1,1,0,0,0-1.23-1.47.72.72,0,0,0-.4.74s-.33-.5.52-1.3a4.8,4.8,0,0,1,.45-.41l-.47-.33a5.22,5.22,0,0,1-.24.56c-.47,1.07-1,.93-1,.93a.72.72,0,0,0,.56-.63,1,1,0,0,0-1.79-.67C68.34,144.54,69.54,146.73,69.54,146.73Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M67,150.38s2.46.4,3.44-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.08.71.71,0,0,0-.4.74s-.32-.5.52-1.31c.12-.12.27-.25.45-.4l-.47-.33c-.08.22-.16.4-.23.56-.48,1.06-1.06.92-1.06.92a.73.73,0,0,0,.57-.62,1,1,0,0,0-.42-.91,1,1,0,0,0-1.38.24C65.76,148.2,67,150.38,67,150.38Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M96.34,134.77s2.46.39,3.45-1a1,1,0,0,0-.24-1.38,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.33-.5.52-1.31c.12-.12.26-.25.44-.4l-.46-.33a5.22,5.22,0,0,1-.24.56c-.47,1.06-1,.92-1,.92a.7.7,0,0,0,.56-.62,1,1,0,0,0-.41-.91,1,1,0,0,0-1.39.24C95.14,132.58,96.34,134.77,96.34,134.77Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M93.77,138.42s2.46.4,3.44-1A1,1,0,0,0,97,136a1,1,0,0,0-1-.09.73.73,0,0,0-.4.75s-.33-.5.52-1.31c.12-.12.27-.26.45-.41l-.47-.33a4.46,4.46,0,0,1-.24.56c-.47,1.07-1,.93-1,.93a.73.73,0,0,0,.57-.63,1,1,0,0,0-.42-.9,1,1,0,0,0-1.38.24C92.57,136.24,93.77,138.42,93.77,138.42Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M91.19,142.08s2.46.39,3.44-1a1,1,0,0,0-.23-1.39,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.32-.49.52-1.3c.12-.12.27-.26.45-.41l-.47-.33c-.08.22-.16.41-.23.56-.48,1.07-1,.93-1,.93a.73.73,0,0,0,.56-.63,1,1,0,0,0-.42-.9,1,1,0,0,0-1.38.24C90,139.9,91.19,142.08,91.19,142.08Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M88.61,145.74s2.46.39,3.45-1a1,1,0,0,0-.24-1.38,1,1,0,0,0-1-.09.71.71,0,0,0-.4.74s-.33-.5.51-1.3c.13-.13.27-.26.45-.41l-.47-.33c-.08.22-.16.4-.23.56-.47,1.06-1,.92-1,.92a.7.7,0,0,0,.56-.62,1,1,0,0,0-.41-.91,1,1,0,0,0-1.39.24C87.41,143.55,88.61,145.74,88.61,145.74Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M86,149.4s2.45.39,3.44-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.09.74.74,0,0,0-.4.75s-.33-.5.52-1.31c.12-.12.27-.26.45-.41l-.47-.33a5.46,5.46,0,0,1-.24.57c-.47,1.06-1,.92-1,.92a.71.71,0,0,0,.56-.63,1,1,0,0,0-.41-.9,1,1,0,0,0-1.38.24C84.84,147.21,86,149.4,86,149.4Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M83.46,153.05s2.46.4,3.44-1a1,1,0,0,0-.24-1.38,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.32-.49.52-1.3c.12-.12.27-.26.45-.41l-.47-.33c-.08.22-.16.41-.23.56-.48,1.07-1.06.93-1.06.93a.73.73,0,0,0,.57-.63,1,1,0,0,0-.42-.9,1,1,0,0,0-1.38.24C82.26,150.87,83.46,153.05,83.46,153.05Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M100.3,138.33s2.46.4,3.44-1a1,1,0,0,0-.24-1.38,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.32-.49.52-1.3c.12-.12.27-.26.45-.41l-.47-.33c-.08.22-.16.4-.23.56-.48,1.07-1.06.93-1.06.93a.73.73,0,0,0,.57-.63,1,1,0,0,0-1.81-.66C99.1,136.15,100.3,138.33,100.3,138.33Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M97.72,142s2.46.39,3.44-1a1,1,0,0,0-1.23-1.47.72.72,0,0,0-.4.74s-.32-.5.52-1.3a4.8,4.8,0,0,1,.45-.41l-.46-.33-.24.56c-.48,1.07-1,.92-1,.92a.71.71,0,0,0,.56-.62,1,1,0,0,0-.42-.91,1,1,0,0,0-1.38.24C96.52,139.81,97.72,142,97.72,142Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M95.14,145.65s2.46.39,3.45-1a1,1,0,0,0-1.23-1.48.73.73,0,0,0-.4.75s-.33-.5.51-1.31l.45-.41-.46-.32c-.09.21-.17.4-.24.55-.47,1.07-1,.93-1,.93a.73.73,0,0,0,.56-.62,1,1,0,0,0-.42-.91,1,1,0,0,0-1.38.24C93.94,143.46,95.14,145.65,95.14,145.65Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M92.57,149.3s2.45.4,3.44-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.33-.49.52-1.3l.44-.41-.46-.33a4.46,4.46,0,0,1-.24.56c-.47,1.07-1,.93-1,.93a.72.72,0,0,0,.56-.63,1,1,0,0,0-.41-.9,1,1,0,0,0-1.39.24C91.37,147.12,92.57,149.3,92.57,149.3Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M90,153s2.46.39,3.44-1a1,1,0,0,0-1.23-1.47.72.72,0,0,0-.4.74s-.32-.49.52-1.3c.12-.12.27-.26.45-.41l-.47-.33c-.08.22-.16.41-.23.56-.48,1.07-1.06.93-1.06.93a.73.73,0,0,0,.57-.63,1,1,0,0,0-.42-.9,1,1,0,0,0-1.38.24C88.79,150.78,90,153,90,153Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M87.41,156.62s2.46.39,3.45-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.08.73.73,0,0,0-.41.74s-.32-.5.52-1.3a4.8,4.8,0,0,1,.45-.41l-.47-.33c-.08.22-.16.4-.23.56-.48,1.06-1,.92-1,.92a.72.72,0,0,0,.56-.62,1,1,0,0,0-.42-.91,1,1,0,0,0-1.38.24C86.21,154.43,87.41,156.62,87.41,156.62Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M107.58,137.38s2.46.4,3.45-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.08.71.71,0,0,0-.4.74s-.33-.5.52-1.31l.44-.41-.46-.32c-.09.22-.16.4-.24.56-.47,1.06-1,.92-1,.92a.71.71,0,0,0,.56-.62,1,1,0,0,0-.41-.91,1,1,0,0,0-1.39.24C106.38,135.2,107.58,137.38,107.58,137.38Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M105,141s2.45.4,3.44-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.33-.49.52-1.3c.12-.12.27-.26.45-.41l-.47-.33a4.46,4.46,0,0,1-.24.56c-.47,1.07-1,.93-1,.93a.73.73,0,0,0,.57-.63,1,1,0,0,0-1.81-.66C103.81,138.86,105,141,105,141Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M102.43,144.7s2.46.39,3.44-1a1,1,0,0,0-1.23-1.47.72.72,0,0,0-.4.74s-.32-.5.52-1.3a4.8,4.8,0,0,1,.45-.41l-.47-.33c-.08.22-.16.4-.23.56-.48,1.07-1.05.93-1.05.93a.73.73,0,0,0,.56-.63,1,1,0,0,0-.42-.9,1,1,0,0,0-1.38.24C101.23,142.52,102.43,144.7,102.43,144.7Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M99.85,148.36s2.46.39,3.45-1a1,1,0,0,0-.24-1.38,1,1,0,0,0-1-.09.72.72,0,0,0-.39.74s-.33-.5.51-1.3c.13-.13.27-.26.45-.41l-.47-.33c-.08.22-.16.4-.23.56-.47,1.06-1.05.92-1.05.92a.71.71,0,0,0,.56-.62,1,1,0,0,0-.41-.91,1,1,0,0,0-1.39.24C98.65,146.17,99.85,148.36,99.85,148.36Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M97.28,152s2.45.4,3.44-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.09.74.74,0,0,0-.4.75s-.33-.5.52-1.31c.12-.12.27-.26.45-.41l-.47-.33a4.46,4.46,0,0,1-.24.56c-.47,1.07-1,.93-1,.93a.72.72,0,0,0,.56-.63,1,1,0,0,0-1.8-.66C96.08,149.83,97.28,152,97.28,152Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M94.7,155.67s2.45.4,3.44-1a1,1,0,0,0-.24-1.38,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.32-.49.52-1.3c.12-.12.27-.26.45-.41l-.47-.33c-.08.22-.16.41-.23.56-.48,1.07-1.06.93-1.06.93a.73.73,0,0,0,.57-.63,1,1,0,0,0-.42-.9,1,1,0,0,0-1.38.24C93.5,153.49,94.7,155.67,94.7,155.67Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M91.7,132.85s2.46.4,3.44-1a1,1,0,0,0-1.23-1.47.72.72,0,0,0-.4.74s-.32-.5.52-1.3c.12-.12.27-.26.45-.41l-.47-.33c-.08.22-.16.4-.23.56-.48,1.07-1.06.93-1.06.93a.73.73,0,0,0,.57-.63,1,1,0,0,0-1.81-.66C90.5,130.67,91.7,132.85,91.7,132.85Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M89.12,136.51s2.46.39,3.45-1a1,1,0,0,0-.24-1.38,1,1,0,0,0-1-.09.72.72,0,0,0-.41.74s-.32-.5.52-1.3a4.8,4.8,0,0,1,.45-.41l-.46-.33-.24.56c-.48,1.06-1,.92-1,.92a.72.72,0,0,0,.56-.62,1,1,0,0,0-1.8-.67C87.92,134.32,89.12,136.51,89.12,136.51Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M86.54,140.16s2.46.4,3.45-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.09.71.71,0,0,0-.4.75s-.33-.5.52-1.31c.12-.12.26-.26.44-.41l-.46-.33c-.09.22-.16.41-.24.56-.47,1.07-1.05.93-1.05.93a.72.72,0,0,0,.56-.63,1,1,0,0,0-.41-.9,1,1,0,0,0-1.39.24C85.34,138,86.54,140.16,86.54,140.16Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M84,143.82s2.45.4,3.44-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.33-.49.52-1.3c.12-.12.27-.26.45-.41l-.47-.33a5.22,5.22,0,0,1-.24.56c-.47,1.07-1.05.93-1.05.93a.7.7,0,0,0,.56-.63,1,1,0,0,0-.41-.9,1,1,0,0,0-1.39.24C82.77,141.64,84,143.82,84,143.82Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M81.39,147.48s2.46.39,3.44-1a1,1,0,0,0-.23-1.38,1,1,0,0,0-1-.09.72.72,0,0,0-.4.74s-.32-.5.52-1.3a4.8,4.8,0,0,1,.45-.41l-.47-.33c-.08.22-.16.4-.23.56-.48,1.07-1.06.93-1.06.93a.73.73,0,0,0,.57-.63,1,1,0,0,0-1.8-.67C80.19,145.29,81.39,147.48,81.39,147.48Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M78.81,151.13s2.46.4,3.45-1a1,1,0,0,0-.24-1.39,1,1,0,0,0-1-.08.7.7,0,0,0-.4.74s-.33-.5.51-1.31l.45-.4-.46-.33c-.09.22-.17.4-.24.56-.48,1.06-1,.92-1,.92a.72.72,0,0,0,.56-.62,1,1,0,0,0-1.8-.67C77.61,149,78.81,151.13,78.81,151.13Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M93.49,200.69s3.69,4,3.69,8.72c0,0-11.25-1.25-13.25-6.88C83.93,202.53,90.42,201.85,93.49,200.69Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M74.43,203.16s-7,9.25-20.62,5.37c0,0-3.25-2.16,1.37-6.26A95.48,95.48,0,0,0,74.43,203.16Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M88.31,173s-1.17-1.83-.67-1.83a3.1,3.1,0,0,0,2.17-2.5S91.48,171,88.31,173Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.63,198.46c.38-1.82,3.3-2.05-1-8.47-3.27-4.89-.31-7.39.83-11.33,2.84-9.75,1.17-15-8-17.67,0,0,14.75-.83,10.42,13S78,188.07,79,191.57c.64,2.23-.33,5.08-1.66,6.84Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70.31,198s1.87-3.37-2.63-10.12c-5.24-7.86,3.75-12.5-1.37-20.13s-13-5.85-15.43-5.74c0,0,11.3-1.38,14.43,6.12s-3,13.87,1.12,20.62S70.31,196.91,70.31,198Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.53,115.39l-9.2,11.49,3.52,2.17a15.32,15.32,0,0,1,3.77,4.42c.34.68,2.32-.07.61-3l-1.39-2.85,6.45,5.31s3.54,3.21,3.69,1.73c.1-.94-1.29-2.86-1.88-3.26s-4.88-5.44-4.88-5.44l5.24,3.93s3.88,3.19,4.21,2.66c1.25-2-1.3-3.76-2-4.21s-5.79-5-5.79-5l6.88,3.87s2.63,1.89,2.82,1.17c.46-1.76-1.39-3-1.77-3.21-.69-.4-5.81-3.81-5.81-3.81l1.8.25s5.3,1.91,5.34,1.45c.19-2.29-9.33-6.27-9.33-6.27A22.21,22.21,0,0,0,128.53,115.39Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.15,124.37l13.43,6-2.14,3.55a15.5,15.5,0,0,0-1.34,5.65c0,.76-2.09,1-1.9-2.39L92.13,134l-3.31,7.67s-1.69,4.47-2.5,3.22c-.52-.78-.15-3.13.19-3.75s1.86-7.07,1.86-7.07L85.5,140s-2,4.6-2.53,4.28c-2-1.19-.56-3.94-.14-4.65s2.85-7.1,2.85-7.1l-4.35,6.58s-1.48,2.88-2,2.33c-1.21-1.36-.13-3.3.11-3.67.43-.67,3.43-6,3.43-6l-1.49,1s-3.84,4.13-4.09,3.74c-1.21-2,5.43-9.84,5.43-9.84A23.12,23.12,0,0,1,84.15,124.37Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-156",
    points: "83.38 124.57 112.79 140.43 133.37 111.33 89.53 115.99 83.55 123.76"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M116.69,140.76s2.89-1.43,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.34,1.34,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.76c0-.22.09-.48.16-.77h-.74c.08.3.14.55.18.77.3,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.12-1.09,1.29,1.29,0,0,0-2.4.66C113.79,139.37,116.69,140.76,116.69,140.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M110.1,140.76s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-1.29-1.28,1.31,1.31,0,0,0-1.11.65.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.74a6.8,6.8,0,0,1,.18.77c.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C107.19,139.37,110.1,140.76,110.1,140.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M129.89,140.76s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-1.29-1.28,1.31,1.31,0,0,0-1.11.65.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.74a6.8,6.8,0,0,1,.18.77c.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C127,139.37,129.89,140.76,129.89,140.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M123.29,140.76s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74c.08.3.13.55.17.77.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C120.38,139.37,123.29,140.76,123.29,140.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M90.41,140.76s2.88-1.43,2.86-3.65A1.28,1.28,0,0,0,92,135.83a1.31,1.31,0,0,0-1.11.65.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.76a6.12,6.12,0,0,1,.17-.77H90c.08.3.13.55.17.77.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C87.5,139.37,90.41,140.76,90.41,140.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M83.81,140.76s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.76c0-.22.09-.48.17-.77H83.4a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.13-1.09,1.29,1.29,0,0,0-2.4.66C80.91,139.37,83.81,140.76,83.81,140.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M103.6,140.76s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.13-1.09,1.29,1.29,0,0,0-2.4.66C100.7,139.37,103.6,140.76,103.6,140.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M97,140.76s2.89-1.43,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.32,1.32,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.76a5.91,5.91,0,0,1,.16-.77h-.74c.08.3.14.55.18.77.3,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.12-1.09,1.29,1.29,0,0,0-2.4.66C94.1,139.37,97,140.76,97,140.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M100.05,139.31s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.92.92,0,0,0-.14-1.08s.72.28.44,1.76a6.12,6.12,0,0,1-.17.77h.74c-.08-.3-.13-.55-.17-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.09,1.28,1.28,0,0,0,2.39-.66C103,140.7,100.05,139.31,100.05,139.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M106.65,139.31s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.17.77h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.77.41-1.77a1,1,0,0,0-.13,1.09,1.29,1.29,0,0,0,2.4-.66C109.55,140.7,106.65,139.31,106.65,139.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M86.86,139.31S84,140.74,84,143a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.17.77h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.77.41-1.77a1,1,0,0,0-.13,1.09,1.29,1.29,0,0,0,2.4-.66C89.76,140.7,86.86,139.31,86.86,139.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M93.46,139.31s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,1.29,1.28,1.32,1.32,0,0,0,1.12-.66,1,1,0,0,0-.14-1.08s.71.28.43,1.76a5.91,5.91,0,0,1-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.09,1.29,1.29,0,0,0,2.4-.66C96.36,140.7,93.46,139.31,93.46,139.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M126.34,139.31s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.71.28.44,1.76c0,.22-.09.48-.17.77h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.4-1.77.4-1.77a1,1,0,0,0-.12,1.09,1.29,1.29,0,0,0,2.4-.66C129.24,140.7,126.34,139.31,126.34,139.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M132.94,139.31s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.28.43,1.76c0,.22-.09.48-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.09,1.26,1.26,0,0,0,1.12.63,1.28,1.28,0,0,0,1.28-1.29C135.84,140.7,132.94,139.31,132.94,139.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M113.15,139.31s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.28.43,1.76c0,.22-.09.48-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.09,1.26,1.26,0,0,0,1.12.63,1.28,1.28,0,0,0,1.28-1.29C116.05,140.7,113.15,139.31,113.15,139.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M119.74,139.31s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.92.92,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.16.77h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.09,1.28,1.28,0,0,0,2.39-.66C122.65,140.7,119.74,139.31,119.74,139.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M116.69,131.32s2.89-1.43,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.32,1.32,0,0,0-1.12.66,1,1,0,0,0,.14,1.08s-.71-.28-.43-1.76c0-.22.09-.48.16-.77h-.74c.08.3.14.55.18.77.3,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.12-1.09,1.29,1.29,0,0,0-2.4.66C113.79,129.93,116.69,131.32,116.69,131.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M110.1,131.32s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.74a6.8,6.8,0,0,1,.18.77c.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C107.19,129.93,110.1,131.32,110.1,131.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M129.89,131.32s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.74a6.8,6.8,0,0,1,.18.77c.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C127,129.93,129.89,131.32,129.89,131.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M123.29,131.32s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74c.08.3.13.55.17.77.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C120.38,129.93,123.29,131.32,123.29,131.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M90.41,131.32s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.28-.44-1.76a6.12,6.12,0,0,1,.17-.77H90c.08.3.13.55.17.77.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.09,1.28,1.28,0,0,0-2.39.66C87.5,129.93,90.41,131.32,90.41,131.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M83.81,131.32s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.17-.77H83.4a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.13-1.09,1.29,1.29,0,0,0-2.4.66C80.91,129.93,83.81,131.32,83.81,131.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M103.6,131.32s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.13-1.09,1.29,1.29,0,0,0-2.4.66C100.7,129.93,103.6,131.32,103.6,131.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M97,131.32s2.89-1.43,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.31,1.31,0,0,0-1.12.66,1,1,0,0,0,.14,1.08s-.71-.28-.43-1.76a5.91,5.91,0,0,1,.16-.77h-.74c.08.3.14.55.18.77.3,1.48-.41,1.77-.41,1.77a1,1,0,0,0,.12-1.09,1.29,1.29,0,0,0-2.4.66C94.1,129.93,97,131.32,97,131.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M100.05,129.87s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77a6.41,6.41,0,0,1-.17.76h.74c-.08-.3-.13-.55-.17-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.09,1.28,1.28,0,0,0,2.39-.66C103,131.26,100.05,129.87,100.05,129.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M106.65,129.87s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.32,1.32,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.77.41-1.77a1,1,0,0,0-.13,1.09,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C109.55,131.26,106.65,129.87,106.65,129.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M86.86,129.87S84,131.3,84,133.52a1.29,1.29,0,0,0,1.3,1.28,1.32,1.32,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.41-1.77.41-1.77a1,1,0,0,0-.13,1.09,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C89.76,131.26,86.86,129.87,86.86,129.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M93.46,129.87s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,1.29,1.28,1.34,1.34,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.09,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C96.36,131.26,93.46,129.87,93.46,129.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M126.34,129.87s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.44,1.77c0,.21-.09.47-.17.76h.74a6.52,6.52,0,0,1-.17-.77c-.31-1.48.4-1.77.4-1.77a1,1,0,0,0-.12,1.09,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C129.24,131.26,126.34,129.87,126.34,129.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M132.94,129.87s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.09,1.29,1.29,0,0,0,2.4-.66C135.84,131.26,132.94,129.87,132.94,129.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M113.15,129.87s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.09,1.29,1.29,0,0,0,2.4-.66C116.05,131.26,113.15,129.87,113.15,129.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M119.74,129.87s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.16.76h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.09,1.28,1.28,0,0,0,2.39-.66C122.65,131.26,119.74,129.87,119.74,129.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M116.69,121.88s2.89-1.43,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.32,1.32,0,0,0-1.12.66,1,1,0,0,0,.14,1.08s-.71-.28-.43-1.76c0-.22.09-.48.16-.77h-.74c.08.3.14.55.18.77.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C113.79,120.49,116.69,121.88,116.69,121.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M110.1,121.88s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.74a6.8,6.8,0,0,1,.18.77c.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C107.19,120.49,110.1,121.88,110.1,121.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M129.89,121.88s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.16-.77h-.74a6.8,6.8,0,0,1,.18.77c.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C127,120.49,129.89,121.88,129.89,121.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M123.29,121.88s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74c.08.3.13.55.17.77.31,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.27,1.27,0,0,0-1.12-.64,1.29,1.29,0,0,0-1.27,1.3C120.38,120.49,123.29,121.88,123.29,121.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M90.41,121.88s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.28-.44-1.76a6.12,6.12,0,0,1,.17-.77H90c.08.3.13.55.17.77.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C87.5,120.49,90.41,121.88,90.41,121.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M83.81,121.88s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.17-.77H83.4a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.29,1.29,0,0,0-2.4.66C80.91,120.49,83.81,121.88,83.81,121.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M103.6,121.88s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.72-.28-.44-1.76c0-.22.09-.48.17-.77h-.74a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.29,1.29,0,0,0-2.4.66C100.7,120.49,103.6,121.88,103.6,121.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M97,121.88s2.89-1.43,2.87-3.65A1.28,1.28,0,0,0,98.58,117a1.31,1.31,0,0,0-1.12.66,1,1,0,0,0,.14,1.08s-.71-.28-.43-1.76a5.91,5.91,0,0,1,.16-.77h-.74c.08.3.14.55.18.77.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C94.1,120.49,97,121.88,97,121.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M100.05,120.43s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.63.94.94,0,0,0-.14-1.09s.72.28.44,1.77a6,6,0,0,1-.17.76h.74c-.08-.29-.13-.55-.17-.77-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08A1.28,1.28,0,0,0,103,124C103,121.82,100.05,120.43,100.05,120.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M106.65,120.43s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.63,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.22-.09.47-.17.76h.74a6.12,6.12,0,0,1-.17-.77c-.31-1.48.41-1.76.41-1.76a.93.93,0,0,0-.13,1.08,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C109.55,121.82,106.65,120.43,106.65,120.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M86.86,120.43S84,121.86,84,124.08a1.29,1.29,0,0,0,2.41.63,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.22-.09.47-.17.76h.74a6.12,6.12,0,0,1-.17-.77c-.31-1.48.41-1.76.41-1.76a.93.93,0,0,0-.13,1.08,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C89.76,121.82,86.86,120.43,86.86,120.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M93.46,120.43s-2.89,1.43-2.87,3.65a1.27,1.27,0,0,0,1.29,1.28,1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a5.8,5.8,0,0,1-.16.76h.74c-.08-.29-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76A.93.93,0,0,0,94,124.7a1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C96.36,121.82,93.46,120.43,93.46,120.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M126.34,120.43s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.63,1,1,0,0,0-.14-1.09s.71.28.44,1.77c0,.22-.09.47-.17.76h.74a6.12,6.12,0,0,1-.17-.77c-.31-1.48.4-1.76.4-1.76a1,1,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C129.24,121.82,126.34,120.43,126.34,120.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M132.94,120.43s-2.89,1.43-2.87,3.65a1.27,1.27,0,0,0,1.29,1.28,1.29,1.29,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.22-.09.47-.16.76h.74c-.08-.29-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C135.84,121.82,132.94,120.43,132.94,120.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M113.15,120.43s-2.89,1.43-2.87,3.65a1.27,1.27,0,0,0,1.29,1.28,1.29,1.29,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.22-.09.47-.16.76h.74c-.08-.29-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C116.05,121.82,113.15,120.43,113.15,120.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M119.74,120.43s-2.88,1.43-2.86,3.65a1.27,1.27,0,0,0,1.29,1.28,1.29,1.29,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77c0,.22-.09.47-.16.76h.74a6.33,6.33,0,0,1-.18-.77c-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C122.65,121.82,119.74,120.43,119.74,120.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M116.69,112.45s2.89-1.44,2.87-3.66a1.27,1.27,0,0,0-1.29-1.27,1.29,1.29,0,0,0-1.12.65,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.55.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C113.79,111.05,116.69,112.45,116.69,112.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M110.1,112.45S113,111,113,108.79a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74a6.69,6.69,0,0,1,.18.76c.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C107.19,111.05,110.1,112.45,110.1,112.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M129.89,112.45s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74a6.69,6.69,0,0,1,.18.76c.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C127,111.05,129.89,112.45,129.89,112.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M123.29,112.45s2.88-1.44,2.87-3.66a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.55.17.76.31,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C120.38,111.05,123.29,112.45,123.29,112.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M90.41,112.45s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76a6.52,6.52,0,0,1,.17-.77H90c.08.29.13.55.17.76.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C87.5,111.05,90.41,112.45,90.41,112.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M83.81,112.45s2.89-1.44,2.87-3.66a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.17-.77H83.4a6.41,6.41,0,0,1,.17.76c.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.32,1.32,0,0,0-1.12-.64,1.29,1.29,0,0,0-1.28,1.3C80.91,111.05,83.81,112.45,83.81,112.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M103.6,112.45s2.89-1.44,2.87-3.66a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.17-.77h-.74a6.41,6.41,0,0,1,.17.76c.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.32,1.32,0,0,0-1.12-.64,1.29,1.29,0,0,0-1.28,1.3C100.7,111.05,103.6,112.45,103.6,112.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M97,112.45s2.89-1.44,2.87-3.66a1.29,1.29,0,0,0-2.41-.62,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76a6.27,6.27,0,0,1,.16-.77h-.74c.08.29.14.55.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C94.1,111.05,97,112.45,97,112.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M100.05,111s-2.88,1.44-2.87,3.66a1.29,1.29,0,0,0,2.41.62.92.92,0,0,0-.14-1.08s.72.27.44,1.76a6.52,6.52,0,0,1-.17.77h.74c-.08-.29-.13-.55-.17-.77-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C103,112.38,100.05,111,100.05,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M106.65,111s-2.89,1.44-2.87,3.66a1.28,1.28,0,0,0,1.3,1.27,1.3,1.3,0,0,0,1.11-.65.93.93,0,0,0-.14-1.08s.72.27.44,1.76c0,.22-.09.47-.17.77h.74a6.12,6.12,0,0,1-.17-.77c-.31-1.48.41-1.76.41-1.76a.93.93,0,0,0-.13,1.08,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C109.55,112.38,106.65,111,106.65,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M86.86,111S84,112.43,84,114.65a1.28,1.28,0,0,0,1.3,1.27,1.3,1.3,0,0,0,1.11-.65.93.93,0,0,0-.14-1.08s.72.27.44,1.76c0,.22-.09.47-.17.77h.74a6.12,6.12,0,0,1-.17-.77c-.31-1.48.41-1.76.41-1.76a.93.93,0,0,0-.13,1.08,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C89.76,112.38,86.86,111,86.86,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M93.46,111s-2.89,1.44-2.87,3.66a1.27,1.27,0,0,0,1.29,1.27,1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.08s.71.27.43,1.76a6.27,6.27,0,0,1-.16.77h.74c-.08-.29-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C96.36,112.38,93.46,111,93.46,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M126.34,111s-2.89,1.44-2.87,3.66a1.29,1.29,0,0,0,2.41.62.93.93,0,0,0-.14-1.08s.71.27.44,1.76c0,.22-.09.47-.17.77h.74a6.12,6.12,0,0,1-.17-.77c-.31-1.48.4-1.76.4-1.76a1,1,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.29,1.29,0,0,0,1.28-1.3C129.24,112.38,126.34,111,126.34,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M132.94,111s-2.89,1.44-2.87,3.66a1.27,1.27,0,0,0,1.29,1.27,1.29,1.29,0,0,0,1.11-.65.93.93,0,0,0-.13-1.08s.71.27.43,1.76c0,.22-.09.47-.16.77h.74c-.08-.29-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C135.84,112.38,132.94,111,132.94,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M113.15,111s-2.89,1.44-2.87,3.66a1.27,1.27,0,0,0,1.29,1.27,1.29,1.29,0,0,0,1.11-.65.93.93,0,0,0-.13-1.08s.71.27.43,1.76c0,.22-.09.47-.16.77h.74c-.08-.29-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C116.05,112.38,113.15,111,113.15,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M119.74,111s-2.88,1.44-2.86,3.66a1.27,1.27,0,0,0,1.29,1.27,1.29,1.29,0,0,0,1.11-.65.92.92,0,0,0-.14-1.08s.72.27.44,1.76c0,.22-.09.47-.16.77h.74a6.33,6.33,0,0,1-.18-.77c-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C122.65,112.38,119.74,111,119.74,111Z"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "112.48 140.65 108.78 138.47 127.87 112.04 133.3 111.22 112.48 140.65"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M68.53,123.32s3.25.77,4.72-1a1.34,1.34,0,0,0-.19-1.88,1.35,1.35,0,0,0-1.32-.22,1,1,0,0,0-.61,1s-.39-.7.83-1.7a6.88,6.88,0,0,1,.64-.5l-.6-.49a7,7,0,0,1-.37.73c-.74,1.38-1.5,1.14-1.5,1.14a1,1,0,0,0,.82-.79,1.35,1.35,0,0,0-.47-1.25,1.33,1.33,0,0,0-1.88.18C67.13,120.28,68.53,123.32,68.53,123.32Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M64.71,128s3.25.77,4.72-1a1.34,1.34,0,0,0-.19-1.88,1.35,1.35,0,0,0-1.32-.22,1,1,0,0,0-.61,1s-.39-.7.83-1.7a6.88,6.88,0,0,1,.64-.5l-.59-.49c-.14.29-.26.53-.38.73-.74,1.38-1.5,1.14-1.5,1.14a1,1,0,0,0,.82-.79,1.34,1.34,0,0,0-2.35-1.07C63.31,124.92,64.71,128,64.71,128Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M60.89,132.62s3.25.77,4.72-1a1.34,1.34,0,0,0-1.51-2.1,1,1,0,0,0-.61,1s-.39-.7.83-1.7a6.88,6.88,0,0,1,.64-.5l-.59-.49c-.14.29-.26.53-.38.73-.74,1.38-1.5,1.14-1.5,1.14a1,1,0,0,0,.82-.79A1.34,1.34,0,0,0,61,127.79C59.49,129.57,60.89,132.62,60.89,132.62Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M57.07,137.27s3.25.77,4.72-1a1.34,1.34,0,0,0-.19-1.88,1.33,1.33,0,0,0-1.32-.22,1,1,0,0,0-.61,1s-.39-.7.83-1.7a6.88,6.88,0,0,1,.64-.5l-.59-.49c-.14.29-.26.52-.38.73-.74,1.38-1.5,1.13-1.5,1.13a1,1,0,0,0,.82-.78,1.34,1.34,0,0,0-2.35-1.07C55.67,134.22,57.07,137.27,57.07,137.27Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M53.25,141.92s3.25.77,4.72-1a1.34,1.34,0,0,0-.19-1.88,1.33,1.33,0,0,0-1.32-.22,1,1,0,0,0-.61.95s-.39-.69.83-1.69c.17-.15.38-.32.64-.51l-.6-.48c-.13.28-.25.52-.37.73-.74,1.38-1.5,1.13-1.5,1.13a1,1,0,0,0,.82-.78,1.37,1.37,0,0,0-.47-1.26,1.34,1.34,0,0,0-1.88.19C51.85,138.87,53.25,141.92,53.25,141.92Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M49.43,146.56s3.25.78,4.72-1a1.34,1.34,0,0,0-.19-1.88,1.33,1.33,0,0,0-1.32-.22,1,1,0,0,0-.61.95s-.39-.69.83-1.69c.17-.15.38-.32.64-.51l-.59-.48c-.14.28-.26.52-.38.72-.74,1.39-1.5,1.14-1.5,1.14a1,1,0,0,0,.82-.78,1.37,1.37,0,0,0-.47-1.26,1.34,1.34,0,0,0-1.88.19C48,143.52,49.43,146.56,49.43,146.56Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M45.61,151.21s3.25.78,4.72-1a1.36,1.36,0,0,0-.19-1.89,1.33,1.33,0,0,0-1.32-.21,1,1,0,0,0-.61.95s-.39-.7.83-1.69c.17-.15.38-.32.64-.51l-.59-.49c-.14.29-.26.53-.38.73-.74,1.39-1.5,1.14-1.5,1.14a1,1,0,0,0,.82-.78,1.37,1.37,0,0,0-.47-1.26,1.34,1.34,0,0,0-1.88.19C44.21,148.17,45.61,151.21,45.61,151.21Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M41.78,155.86s3.26.78,4.73-1a1.36,1.36,0,0,0-.19-1.89,1.33,1.33,0,0,0-1.32-.21,1,1,0,0,0-.61,1s-.39-.7.82-1.69a6.74,6.74,0,0,1,.65-.51l-.6-.49a7,7,0,0,1-.37.73c-.74,1.38-1.5,1.14-1.5,1.14a1,1,0,0,0,.82-.78,1.36,1.36,0,0,0-.47-1.26,1.33,1.33,0,0,0-1.88.19C40.39,152.82,41.78,155.86,41.78,155.86Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.27,124.17s2.7.64,3.91-.83a1.11,1.11,0,0,0-1.25-1.74.78.78,0,0,0-.5.79s-.32-.58.68-1.41c.15-.12.32-.26.54-.42l-.49-.4-.31.6c-.62,1.15-1.25.94-1.25.94a.8.8,0,0,0,.68-.64,1.13,1.13,0,0,0-.39-1,1.11,1.11,0,0,0-1.56.16C58.12,121.64,59.27,124.17,59.27,124.17Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.09,128s2.71.65,3.92-.83a1.11,1.11,0,0,0-1.25-1.74.78.78,0,0,0-.5.79s-.32-.58.68-1.41c.15-.12.32-.26.53-.41L59,124c-.12.24-.22.44-.32.6-.61,1.15-1.24,1-1.24,1a.82.82,0,0,0,.68-.65,1.11,1.11,0,0,0-2-.89C54.94,125.49,56.09,128,56.09,128Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.92,131.88s2.71.64,3.92-.84a1.11,1.11,0,0,0-.15-1.56,1.13,1.13,0,0,0-1.1-.18.8.8,0,0,0-.5.79s-.33-.58.68-1.4c.15-.13.32-.27.53-.42l-.49-.41a6.81,6.81,0,0,1-.31.61c-.61,1.14-1.25.94-1.25.94a.79.79,0,0,0,.68-.65,1.1,1.1,0,0,0-1.94-.89C51.77,129.35,52.92,131.88,52.92,131.88Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.75,135.73s2.7.64,3.92-.83a1.11,1.11,0,0,0-1.25-1.75.83.83,0,0,0-.51.8s-.32-.58.69-1.41c.14-.13.32-.26.53-.42l-.49-.4a6.51,6.51,0,0,1-.31.6c-.62,1.15-1.25.94-1.25.94a.8.8,0,0,0,.68-.65,1.1,1.1,0,0,0-1.94-.88C48.6,133.2,49.75,135.73,49.75,135.73Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.58,139.58s2.7.65,3.92-.83a1.1,1.1,0,0,0-.16-1.56,1.09,1.09,0,0,0-1.09-.18.8.8,0,0,0-.51.79s-.32-.58.69-1.41c.14-.12.32-.26.53-.41l-.49-.41a5.43,5.43,0,0,1-.31.6c-.62,1.15-1.25,1-1.25,1a.81.81,0,0,0,.68-.65,1.09,1.09,0,0,0-.39-1,1.11,1.11,0,0,0-1.56.15C45.43,137.05,46.58,139.58,46.58,139.58Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.41,143.43s2.7.65,3.91-.83a1.11,1.11,0,0,0-1.24-1.74.81.81,0,0,0-.51.79s-.32-.58.68-1.4q.22-.19.54-.42l-.49-.41A6.81,6.81,0,0,1,46,140c-.62,1.14-1.25.94-1.25.94a.8.8,0,0,0,.68-.65,1.11,1.11,0,0,0-2-.89C42.26,140.9,43.41,143.43,43.41,143.43Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.24,147.29s2.7.64,3.91-.83A1.11,1.11,0,0,0,44,144.9a1.1,1.1,0,0,0-1.09-.19.81.81,0,0,0-.51.79s-.32-.57.68-1.4q.22-.19.54-.42l-.49-.4c-.11.23-.22.43-.31.6-.62,1.15-1.25.94-1.25.94a.81.81,0,0,0,.68-.65,1.11,1.11,0,0,0-2-.89C39.08,144.76,40.24,147.29,40.24,147.29Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.07,151.14s2.69.64,3.91-.83a1.11,1.11,0,0,0-.15-1.56,1.09,1.09,0,0,0-1.09-.18.78.78,0,0,0-.51.79s-.32-.58.68-1.41c.15-.12.32-.26.54-.42l-.5-.4q-.16.36-.3.6c-.62,1.15-1.25.94-1.25.94a.81.81,0,0,0,.68-.64,1.13,1.13,0,0,0-.39-1.05,1.11,1.11,0,0,0-1.56.16C35.92,148.61,37.07,151.14,37.07,151.14Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.89,155s2.7.65,3.92-.83a1.11,1.11,0,0,0-.15-1.56,1.13,1.13,0,0,0-1.1-.18.79.79,0,0,0-.5.79s-.33-.58.68-1.4c.15-.13.32-.27.53-.42l-.49-.41a6.81,6.81,0,0,1-.31.61c-.61,1.14-1.24.94-1.24.94a.83.83,0,0,0,.68-.65A1.11,1.11,0,0,0,34,151C32.74,152.47,33.89,155,33.89,155Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M78.43,211.71S83,209.44,82.91,206a2,2,0,0,0-3.78-1,1.46,1.46,0,0,0,.22,1.7s-1.13-.43-.7-2.76c.06-.35.14-.75.26-1.21H77.74a12.3,12.3,0,0,1,.28,1.2c.49,2.33-.63,2.78-.63,2.78a1.47,1.47,0,0,0,.19-1.7,2,2,0,0,0-3.76,1.05C73.86,209.54,78.43,211.71,78.43,211.71Z"
  })), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    width: 25,
    height: 20,
    transform: "translate(117.79 119.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAUCAYAAAB4d5a9AAAACXBIWXMAAAsSAAALEgHS3X78AAACR0lEQVQ4T62V3W4VMQyEP9tZKnp6Ce+FoBU8YkUPRbwchU1sc+H96YGWohZLK612k8yM7XEkM/lf8fl4m5HBp6tLuf9d/gfI5+NtApgZ7k5kAGxgLwJZmQOoKGYGQGSQkayq2t8OeSpaa7RmjOGoKiLgEWgog4GK1ronznk0VhWtvWaaJsyMzAB3ggKKKJXPSteXr9/S3bm4OKBqtNaICCIDH84YA3evJ7yUXN8c/0ASqkE+Xn2Q3/9PbeL8/Jzzw4GMICJRFQghRBARMnNTsqVrzR9Ul8iy+PrmmFObtk1v375BRDYap+wEM2UMUK1GuHz/bi+8iGBm288xBiJw9uoVh8MFqrIBA6gWW0QwE9xBJLif/eED+K3wVZ8kM5diKqK7QtVqURHdASPITESKaESCsHnlD5ASX5tXRXW43HvfATILOCIWkEBVUZGT9CuUMz18kyoCorIw3sHMdoAiIvv6RclDcapE1qeYqJYiKMY7gCIqZASVXqjyCLLsd/ft2F0TMMag9w5Z75kgS9p0Uaa6g29pI5FF1RiDPndgn10byDY5E+Y+E+Hl4ISIWAxWJsuFekQw3GtOudP7zFgUrB45AVmBPMqxAHd3P5jneZNeXsndzduBTkTw/e6OeZ75Of886a4Hx8r1zTFNjbOzM9SU1hqjD8yUaZpo04SPQe+lzFr5yocz9yJ1/055dHZd3xxTRbFmmBpqytTaMqtq8mbmlr4xOnPvRDzz0loB12k7zzOtNXrvmJVP3J2PVx8e7OF/Anlp/ALmG4V6sc2+JgAAAABJRU5ErkJggg=="
  })), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 83,
    transform: "translate(127.79 134.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAABTCAYAAABXuM0PAAAACXBIWXMAAAsSAAALEgHS3X78AAABqklEQVQ4T6WU227UQBBET/fMspAHFMiHJVJ+Ewn+CyQEQgrxerp4aI9v63AR81iu6qquGdk+fPwkdqcCGHYNujvu+SEicAAzqLVSa8XMqF16qoVaK601qkif8/kVqTKqm2NmnE51ASUBRiklnUtJuQGlOACS0igU1IlZ6sS8uXmD+bKAAyg0zyvuCbZoyfCc648P9zYMF16fz7hnvArQWsy7m0/gu9u3WQDgZjnzMo5Iws2wDo7jiEKYGRgdbEgCy8IrwN37201LGYzcuZ/cSEHvdQYjxNPTMwCfv3ztzBWrz4wQXW3eQYmOzu6K4OfzQCgWMKScq9VMSXPRy8zQNHc9UzHH2kSShNAil8Q4NhB8+/5jFX51Xi6kRcCy6dLnHIl1ySGQrpsXedNbua7kQaK/kz8+3Oeb0e6KY9p9uFx29z6l3+ZkB3b5lvmS/LgQHchFZp7B06nOCbbMvRwtRS9MhBR/IZc4NrqeeSTP38/OCA6NXgg/DJcdk0N3jo3Gcbxman8dpfgxs7W2BVu0a/n8nti4L2cH7tfkINL6bEDr/7s/Mv/T6N/BXyfINCon7qWWAAAAAElFTkSuQmCC"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M54.87,203.25s1.58-.66,1.64-1.84a.68.68,0,0,0-1.25-.41.5.5,0,0,0,0,.58s-.37-.17-.17-1c0-.12.06-.25.11-.4l-.39,0c0,.16.06.3.07.42.11.79-.28.92-.28.92a.5.5,0,0,0,.1-.57.69.69,0,0,0-.57-.38.68.68,0,0,0-.72.65C53.37,202.41,54.87,203.25,54.87,203.25Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M57.94,203.43s1.58-.66,1.65-1.84a.69.69,0,0,0-1.26-.42.5.5,0,0,0,0,.58s-.37-.17-.17-.95a3.63,3.63,0,0,1,.11-.4l-.39,0a4.07,4.07,0,0,1,.06.41c.11.8-.27.93-.27.93a.51.51,0,0,0,.1-.58.69.69,0,0,0-1.3.27C56.45,202.59,57.94,203.43,57.94,203.43Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M61,203.61s1.58-.67,1.65-1.85A.69.69,0,0,0,62,201a.67.67,0,0,0-.61.31.5.5,0,0,0,0,.58s-.37-.17-.17-1c0-.12.06-.25.11-.4l-.39,0c0,.16,0,.3.07.42.11.79-.28.92-.28.92a.5.5,0,0,0,.1-.57.71.71,0,0,0-.57-.38.68.68,0,0,0-.72.65C59.52,202.77,61,203.61,61,203.61Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M64.09,203.78s1.58-.66,1.65-1.84a.68.68,0,0,0-.65-.72.67.67,0,0,0-.61.31.47.47,0,0,0,0,.57s-.38-.17-.18-.95l.12-.4-.39,0c0,.16.05.3.06.41.11.8-.28.93-.28.93a.5.5,0,0,0,.11-.58.68.68,0,0,0-.58-.37.69.69,0,0,0-.72.64C62.59,202.94,64.09,203.78,64.09,203.78Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M67.16,204s1.58-.67,1.65-1.85a.69.69,0,0,0-.64-.72.7.7,0,0,0-.62.31.5.5,0,0,0,0,.58s-.37-.17-.17-.95c0-.12.06-.25.11-.4l-.39,0c0,.16,0,.3.07.42.11.79-.28.92-.28.92a.5.5,0,0,0,.1-.57.71.71,0,0,0-.57-.38.68.68,0,0,0-.72.65C65.67,203.12,67.16,204,67.16,204Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M70.24,204.13s1.58-.66,1.64-1.84a.68.68,0,0,0-1.25-.41.5.5,0,0,0,0,.58s-.37-.18-.17-1c0-.12.07-.25.12-.41l-.4,0a2.7,2.7,0,0,1,.07.41c.11.8-.28.93-.28.93a.48.48,0,0,0,.1-.57.66.66,0,0,0-.57-.38.68.68,0,0,0-.72.64C68.74,203.29,70.24,204.13,70.24,204.13Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M73.53,204.11s1.47-.89,1.36-2.06a.68.68,0,0,0-1.3-.23.49.49,0,0,0,.12.57s-.39-.12-.31-.92c0-.11,0-.25,0-.41l-.39,0a3.54,3.54,0,0,1,.13.39c.22.78-.14,1-.14,1a.5.5,0,0,0,0-.58.68.68,0,0,0-.62-.29.69.69,0,0,0-.62.74C71.93,203.5,73.53,204.11,73.53,204.11Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M76.6,203.83s1.46-.89,1.36-2.06a.69.69,0,0,0-1.31-.23.5.5,0,0,0,.13.57s-.4-.11-.31-.91a3.92,3.92,0,0,1,0-.42l-.39,0q.08.23.12.39c.23.78-.13,1-.13,1a.5.5,0,0,0,0-.58.68.68,0,0,0-1.24.46C75,203.22,76.6,203.83,76.6,203.83Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M79.67,203.55s1.46-.89,1.35-2.06a.67.67,0,0,0-.74-.62.69.69,0,0,0-.56.39.52.52,0,0,0,.12.57s-.39-.11-.31-.91a4.22,4.22,0,0,1,.06-.42l-.4,0a3.05,3.05,0,0,1,.13.4c.23.77-.14.95-.14.95a.5.5,0,0,0,0-.58.7.7,0,0,0-.62-.29.69.69,0,0,0-.62.75C78.06,202.94,79.67,203.55,79.67,203.55Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M82.73,203.27s1.47-.89,1.36-2.06a.68.68,0,0,0-.74-.62.67.67,0,0,0-.56.39.49.49,0,0,0,.12.57s-.39-.11-.31-.91c0-.12,0-.26.05-.42l-.39,0a3.05,3.05,0,0,1,.13.4c.22.77-.14,1-.14,1a.51.51,0,0,0,0-.58.71.71,0,0,0-.63-.29.7.7,0,0,0-.62.75C81.13,202.66,82.73,203.27,82.73,203.27Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M85.8,203s1.46-.89,1.36-2.06a.69.69,0,0,0-.74-.62.66.66,0,0,0-.56.39.49.49,0,0,0,.12.57s-.4-.11-.31-.91a3.92,3.92,0,0,1,0-.42l-.39,0,.13.4c.22.77-.14,1-.14,1a.5.5,0,0,0,0-.58.66.66,0,0,0-.62-.28.68.68,0,0,0-.62.74C84.2,202.38,85.8,203,85.8,203Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M89,202.46s1.37-1,1.16-2.18a.68.68,0,0,0-.8-.54.67.67,0,0,0-.52.44.48.48,0,0,0,.17.55s-.4-.07-.39-.88c0-.12,0-.25,0-.41l-.38.07c.06.14.12.27.16.38.3.75,0,1,0,1a.49.49,0,0,0,0-.58.66.66,0,0,0-.64-.23.68.68,0,0,0-.55.8C87.32,202,89,202.46,89,202.46Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M92,201.9s1.38-1,1.16-2.18a.68.68,0,0,0-1.31-.1.49.49,0,0,0,.17.55s-.4-.07-.39-.88a3.08,3.08,0,0,1,0-.42l-.39.07c.07.15.13.28.17.39.29.75,0,1,0,1a.51.51,0,0,0,0-.58.68.68,0,0,0-.65-.22.67.67,0,0,0-.54.79C90.35,201.44,92,201.9,92,201.9Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11S);
export default __webpack_public_path__ + "static/media/11_s.7495c5b2922d4c5f2af29bcbd5d65da0.svg";
export { ForwardRef as ReactComponent };